import React, { useEffect, useMemo, useReducer, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { enumUtil } from "../../utils/Enum";
import { ServerRequestProtected } from "../../utils/ServerDataRequest";
import { OpenNewEncounterMenuTabAction, TabActionEncounterMenu } from "../../actions/EncounterMenuActions";
import 'react-data-grid/lib/styles.css';
import Loader from "../shared/Loader/Loader";
import { useSelector } from "react-redux";
import { Alphbets } from "../../utils/Constants";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css'; // theme css file
import Table from "../Setup/Shared/Table";
import GridColumnHeader from "../Setup/Shared/GridColumnHeader"
import { EncounterMenuRecordAction } from "../../actions/EncounterMenuActions";
import SearchHeader from "../Setup/Shared/SearchHeader";
import OpenQuickPopup from "../shared/OpenQuickPopup/OpenQuickPopup";
import SuperSearchList from "../shared/SuperSearch/SuperSearchList";
import { Modal } from "react-bootstrap";
import ModalHeader from "../Setup/Shared/ModalHeader";
import DataGrid from 'react-data-grid';
import CalendaRangeInput from "../General/CalendarRangeInput";
import handleCopyText from "../shared/CopyData";
import AmountFormatter from "../../utils/AmountFormatter";
import ContentReceiver from "../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver";
import { FindFirstChild, FindSecondChild } from "../../utils/FindMenuOption";
import SuperSearchMultipleClient from "../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient";
// import { GeneralDropDowns } from "../../actions/GeneralEncounterMenuActions";
import HandleSelectColumnName from "../../utils/HandleSelectColumnName";
import { MainBarActiveTabsAction } from "../../actions/MainBarActiveTabsAction";
import CustomUseRef from "../shared/DropDown/CustomUseRef";
import SuperSearchMultipleServer from "../shared/SuperSearch/MultipleSelection/SuperSearchMultipleServer";
import DeleteConfirmatiom from "../General/DeleteConfirmation";
import Pagination from "../shared/Pagination/Pagination";
import ReloadGridAction from "../../actions/ReloadGridAction";
import NotificationHandler from "../../utils/NotificationHandler";
import useHandleOpenNewBrowserTab from "../shared/NewTabBrowser/useHandleOpenNewBrowserTab";
import NoDataFound from "../shared/NoDataFound/NoDataFound";
import SignEncounter from "../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/Components/SignEncounter";
import SuperSearchSingleClient from "../shared/SuperSearch/SingleSelection/SuperSearchSingleClient";
import DropdownValueHandler from "../shared/SuperSearch/DropdownValueHandler";
import FormValidator from "../../utils/FormValidator";
import handleSetDropdownData from "../../utils/HandleSetDropdownData";
import DatePicker from "../General/DatePicker";
import { createPortal } from "react-dom";
import { useRef } from "react";
import PrintBulkEncounter from "./Components/PrintBulkEncounter";
import isNull from "../../utils/NullChecking";
import { EncounterMenuRecordActions } from "../../actions/BillingActions";
import CurrentMaxDateValidator from "../../utils/CurrentMaxDateValidator";
import useUserData from "../hooks/useUserData";
import AddNewGroupEncounter from "./AddNewGroupEncounter";
import HandleStatus from "../shared/HandleStatus";

const EncounterMenuSearch = (props) => {
    const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();
    const { Settings } = { ...props }

    let isViewAllowed = FindFirstChild('Encounter', 'Encounters')?.ISView
    let isDeleteAllowed = FindFirstChild('Patient', 'Encounter')?.IsDeleted;
    let isClaimViewAllowed = FindSecondChild('Billing', 'Claims', 'Claims')?.ISView
    let SidebarActive = useSelector(state => state.SidebarActiveTab);
    let isSignEditAllowed = FindFirstChild('Patient', 'Sign Encounters')?.IsAdd;
    let isSuperbillEditAllowed = FindFirstChild('Patient', 'Add SuperBill')?.IsAdd;
    let isCreateClaimEditAllowed = FindFirstChild('Patient', 'Create Claim For SuperBill')?.IsAdd;
    let IsEditAllowed = FindFirstChild('Patient', 'Encounter')?.IsAdd

    const { handleLoadUserData } = useUserData();
    let userSignData = useSelector(state => state.UserDataReducer);
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);
    let GridView = useSelector(state => state.SettingsReducer);
    let OpenedEncounters = useSelector(state => state.Open_EncounterMenu_Tab);
    let AddNewEncounter = useSelector(state => state.Open_EncounterMenu_Tab.find(tab => tab.data.id == 0 && tab.active));
    let reloadGrid = useSelector(state => state.ReloadGridReducer)
    const API_URL_PATIENT = enumUtil.controller.PATIENT
    // const API_URL_Agency = enumUtil.controller.AgencyPatient
    let dispatch = useDispatch();
    const [filterShow, setFilterShow] = useState(false);
    let DropdownData = useSelector(state => state.GeneralDropDownsReducer)
    const isHomeCareCheck = DropdownData.IsHomeCare
    const [initialProviderData, setInitialProviderData] = useState(null);
    const [encounterMenuData, setEncounterMenuData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [popup, setPopup] = useState(<></>);
    const [IsFilterApplied, setIsFilterApplied] = useState(false)
    const [showContextMenu, setShowContextMenu] = useState(false);
    const [copiedText, setCopiedText] = useState({});
    let searchFieldData = useSelector(state => state.MainBarActiveTabsReducer?.['Encounter Menu']?.SearchField);
    let searchFieldDataa = useSelector(state => state.MainBarActiveTabsReducer?.EncounterMenu?.SearchField);

    const noteTypesData = [
        ...noteTypes
    ]
    const encounterModeData = [
    ]
    const encounterStatusData = [
        { display: "In Progress", value: "In Progress" },
        { display: "Ready for Review", value: "Ready for Review" },
        { display: "To Be Co-Signed", value: "To Be Co-Signed" },
        { display: "Signed", value: "Signed" },
        { display: "Missing Superbill", value: "Missing Superbill" },
        { display: "Missing Claim", value: "Missing Claim" },
    ];
    const encounterStatusDataSave = [
        // { display: "In Progress", value: "In Progress", ColorCode:'#ffb013' },
        { display: "In Progress", value: "In Progress", ColorCode: 'var(--BlueColor)' },
        { display: "Ready for Review", value: "Ready for Review", ColorCode: '#ffb013' },
    ];
    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////
    const getCurrentDateRange = () => {
        // console.log("DropdownData", DropdownData?.CurrentPracticeDate, )
        // const currentDate = new Date();
        const currentDate = DropdownData?.CurrentPracticeDate;
        // const formattedDate = currentDate.toLocaleDateString('en-US', {
        //     month: '2-digit',
        //     day: '2-digit',
        //     year: 'numeric'
        // });

        return {
            formattedStartDate: currentDate,
            formattedEndDate: currentDate
        };
    };
    const weekDates = useMemo(() => getCurrentDateRange(), []);
    ///Search///
    const Search_Data = {
        "Search": "",
        "InsuranceID": "",
        "ProviderID": "",
        "DOSFrom": "",
        "DOSTo": "",
        "NoteType": "",
        "EncounterType": "",
        "EncounterMode": "",
        "EncounterStatus": "",
        "EntryDateFrom": weekDates.formattedStartDate,
        "EntryDateTo": weekDates.formattedEndDate,
    }
    const searchButton = {
        // AddNew: true,
        Excel: true,
        // PDF: true,
        Delete: false,
        // Filter: true,
        // View: false  // set true if want to display cards as well
    }
    const API_URL = enumUtil.controller.Claim;
    const API_URL_GENERAL = enumUtil.controller.General;
    const API_URL_PatientEncounter = enumUtil.controller.PatientEncounter;
    const API_URL_Patient = enumUtil.controller.Patient;
    const visitTypes = useSelector(state => state.GeneralDropDownsReducer.EncounterType);
    let isHomecareOrADC = useSelector(state => ["Adult Day Care", "Homecare Agency"].includes(state.GeneralDropDownsReducer.PracticeType))
    const [patientValue, setPateintValue] = useState([])
    const [dateType, setDateType] = useState('EntryDate');
    const [dateRange, setDateRange] = useState(null)
    const [searchParam, setSearchParam] = useState(Search_Data);
    const SearchValue_Data = {
        NoteType: '',
        EncounterType: '',
        EncounterStatus: '',
        EncounterMode: ''
    }
    const [searchValue, setSearchValue] = useState(SearchValue_Data)
    const [openTab, setOpenTab] = useState('')
    const [searchLoad, setSearchLoad] = useState(false)
    const [selectedInsurance, setSelectedInsurance] = useState('')
    // const [selectCoordinator, setselectCoordinator] = useState('')
    const [selectprovider, setSelectedProvider] = useState('')
    const [selectLocation, setSelectLocation] = useState('')
    // const [statusDefault, setStatusDefault] = useState([])
    const [statusDefault, setStatusDefault] = useState(searchFieldDataa?.Encounter || []);

    const [bulkSignatureParam, setBulkSignatureParam] = useState()
    const [typeCheckBox, setTypeCheckBox] = useState('');
    const [isOpenBulkSignature, setIsOpenBulkSignature] = useState(false);
    const [isOpenBulkPrint, setIsOpenBulkPrint] = useState(false);
    const [checkBoxShow, setCheckBoxShow] = useState(false);
    const [selectedEncounterIDs, setSelectedEncounterIDs] = useState([])
    const [selectedRows, setSelectedRows] = useState(new Set())
    const [signatureSearchParam, setSignatureSearchParam] = useState({});


    const [subMenuActive, setSubMenuActive] = useState(false);
    const [activeRowId, setActiveRowId] = useState(null);
    const [clear, setClear] = useState(false);
    const [reloadSuperSearch, setReloadSuperSearch] = useState(false)
    const [gridDeleteID, setGridDeleteID] = useState();
    const [isOpenDeleteGrid, setIsOpenDeleteGrid] = useState(false);
    const [del, setDel] = useState(false);
    //For Pagination
    const [PerPage, setPerPage] = useState([1000, '1000'].includes(Settings?.PaginationDefaultRows) ? '500' : Settings?.PaginationDefaultRows);
    const [PageNo, setPageNo] = useState(1);
    const [TotalPages, setTotalPages] = useState();
    const handlePageClick = (page) => { setPageNo(page); }
    const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    const handleFingByCreteria = (e) => {
        setPerPage(e.target.value)
        setPageNo(1)
    }
    const handleSelectData = (data) => {
        setPerPage(data.value)
        setPageNo(1)
    }
    ///////////
    const AddNewEncounterMenu = () => {
        // let dataObj = {
        //     key: 2,
        //     name: "Encounter Menu",
        //     active: true,
        //     data: {
        //         name: "New Encounter Menu",
        //         id: -1,
        //         time: new Date()
        //     },
        // };
        // dispatch(GeneralDropDowns({
        //     ...GenDD, DisCardActiveIds: {
        //         ...GenDD?.DisCardActiveIds,
        //         EncounterMenu: [...GenDD?.DisCardActiveIds.EncounterMenu, {
        //             isDemographicsOpened: false,
        //             isDemographicsUpdated: false,
        //             isInsuranceOpened: false,
        //             isInsuranceUpdated: false,
        //             EncounterMenuID: -1,
        //         }]
        //     }
        // }))
        // props.TabActionEncounterMenu(dataObj);
    }
    const LoadData = (searchParam) => {
        if (!isViewAllowed) return
        setIsLoading(true);
        // let apilink = isHomeCareCheck === "true" ? API_URL_Agency : API_URL_PATIENT
        ServerRequestProtected(API_URL_GENERAL + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.GIRPNote,
            "SearchCriteria": searchParam,
            "PerPage": PerPage,
            "PageNo": PageNo,
        })
            .then((response) => {
                setIsLoading(false);
                setEncounterMenuData(response.Rows)
                setTotalPages(response.count.NumOfPages);

                handleGridHeader({ defaultData: response.Rows })
                let EncounterMenuData = [];
                EncounterMenuData = response.Rows.map((item, index) => {
                    let newlist = { ID: item.EncounterID, name: `${item.FirstName} - ${item.DOS}`, type: item.NoteType, PatientID: item.PatientID };
                    return newlist;

                })
                dispatch(EncounterMenuRecordActions(EncounterMenuData))
                setDel(false);
            }).catch((error) => {
                // console.log("ERROR", error)
                // NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                setEncounterMenuData([])
                setIsLoading(false);
            }).finally(() => {
                handleResetBulkSign();
            })
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            setSearchParam({ ...searchParam, SearchCeriteria: e.target.value })
            SearchByParam(searchParam)
        }
    }
    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const handleApply = () => {
        setIsFilterApplied(true)
        if (!isNull(searchParam)) {
            setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }

    useEffect(() => {
        setDateRange(prev => `${weekDates?.formattedStartDate + '-' + weekDates?.formattedEndDate}`)
    }, [weekDates]);

    useEffect(() => {

        console.log(searchFieldDataa, 'searchFieldDataa');

        ////To set Status field on Navigation from Billing Items////
        if (searchFieldDataa) {
            clearFilter()
            Object.keys(searchParam).forEach(key => searchParam[key] = Search_Data[key]);
            searchParam.EncounterStatus = searchFieldDataa?.Encounter ? searchFieldDataa.Encounter.map(data => data.value)?.join(', ') : "";
            setSearchParam(() => (searchParam));
            setStatusDefault(() => searchFieldDataa?.Encounter);
            dispatch(MainBarActiveTabsAction({ 'EncounterMenu': { ActiveTabKey: 2, SearchField: undefined } }));
        }
        // else if (searchFieldDataa) {

        // }

        if (searchFieldDataa !== undefined) {

            LoadData(searchParam);
        }
    }, [searchFieldDataa])

    useEffect(() => {
        if (!isViewAllowed) return
        // DropdownData.LoginProviderID  = "10037"

        // if (DropdownData.LoginProviderID && initialProviderData === null) {
        //     const data = DropdownData.Provider
        //         ?.filter(item => !['-1', -1].includes(item.value))
        //         .filter(item => String(item.value) === String(DropdownData.LoginProviderID));

        //     setInitialProviderData(data);
        //     searchParam.ProviderID = DropdownData.LoginProviderID;

        //     setSearchParam(() => ({ ...searchParam }));
        //     if (data?.length > 0) {
        //         setReloadSuperSearch(!reloadSuperSearch)
        //     }
        // }
        if (searchFieldData === undefined) {
            setIsLoading(true);
            setEncounterMenuData([])
            LoadData(searchParam)
        }
    }, [PerPage, PageNo, searchLoad]) //seacrhParam

    useEffect(() => {
        if (!isNull(props?.setRecordsNum)) {
            props.setRecordsNum(encounterMenuData.length)
        }
    }, [encounterMenuData])

    useEffect(() => {
        ////To set Status field on Navigation from Billing Items////
        if (searchFieldData) {
            // Set Default Search Data
            Object.keys(searchParam).forEach(key => searchParam[key] = Search_Data[key]);
            searchParam.SearchCeriteria = searchFieldData.SearchCeriteria
            setSearchParam(() => (searchParam))
            dispatch(MainBarActiveTabsAction({ 'EncounterMenu': { ActiveTabKey: 2, SearchField: undefined } }));
        }
        if (searchFieldData !== undefined) {
            LoadData(searchParam);
        }
    }, [searchFieldData]) //seacrhParam
    let GenDD = useSelector(state => state.GeneralDropDownsReducer)

    const OpenEncounterMenu = (encounter) => {
        // let obj = {
        //     key: 2,
        //     name: "Encounter Menu",
        //     active: true,
        //     data: {
        //         id: data.EncounterMenuID,
        //         name: data.FirstName,
        //         FullName: data.LastName + " " + data.FirstName,
        //         time: new Date(),
        //     },
        // };

        let obj = {
            active: true,
            key: 2,
            name: "Encounter Menu",
            data: {
                name: `${encounter.FirstName} - ${encounter.DOS}`,
                id: encounter.EncounterID,
                patid: encounter.PatientID,
                // patID: PatientIDR,
                type: encounter.NoteType,
                time: new Date(),
                groupEncounter: {
                    isGroupEncounter: encounter.IsGroupEncounter,
                    GroupIdentifier: encounter.GroupIdentifier,
                    showGroupNote: false
                }
            },
        }
        // dispatch(TabActionEncounters(obj));      
        // dispatch({
        //     type: 'Open_EncounterMenu_Tab',
        //     payload: {
        //         patientId: PatientIDR,     // <-- needed to find the patient tab to update
        //         tab: obj            // the encounter tab object
        //     }
        // });
        // dispatch(GeneralDropDowns({
        //     ...GenDD, DisCardActiveIds: {
        //         ...GenDD?.DisCardActiveIds,
        //         EncounterMenu: [...GenDD?.DisCardActiveIds.EncounterMenu, {
        //             isDemographicsOpened: false,
        //             isDemographicsUpdated: false,
        //             isInsuranceOpened: false,
        //             isInsuranceUpdated: false,
        //             EncounterMenuID: data.EncounterMenuID,
        //         }]
        //     }
        // }))
        props.TabActionEncounterMenu(obj);
    }
    const OpenEncounterMenuDetails = (data, type) => {
        let obj = {
            key: 2,
            name: "EncounterMenu",
            active: true,
            data: {
                id: data.EncounterMenuID,
                name: data.FirstName,
                time: new Date(),
                type: type,
            },
        };
        // props.TabActionEncounterMenu(obj);
    }
    /////// viewAllClaims ///////
    const handleViewAllClaim = (PatID, PatName) => {
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "All Claims",
                id: 0,
                time: new Date(),
                visitType: {
                    type: 'ClaimSearch',
                    EncounterMenuID: PatID,
                    EncounterMenuName: PatName,
                },
            },
        };
        setOpenTab(dataObj)
    }
    const handleViewAllClaimAccNumber = (PatID, PatName) => {
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "All Claims",
                id: 0,
                time: new Date(),
                visitType: {
                    type: 'ClaimSearch',
                    PatientID: PatID,
                    PatientName: PatName,
                },
            },
        };
        setOpenTab(dataObj)
    }
    const OpenQuickPopupMemoized = ({ row, setPopup, name }) => {
        const memoizedPopup = useMemo(() => {
            if (name === 'Provider') {
                return (
                    <OpenQuickPopup
                        ID={row.ProviderID} name={row.Provider} setPopup={setPopup} popupName={name} />);
            }
            else if (name === 'Insurance') {
                return (
                    <OpenQuickPopup ID={row.InsuranceID} name={row.Insurance} setPopup={setPopup} popupName={name} />);
            }
            else if (name === 'Location') {
                return (
                    <OpenQuickPopup ID={row.LocationID} name={row.LocationName} setPopup={setPopup} popupName={name} />);
            }
        }, [row, name]);

        return memoizedPopup;
    };
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }

    const handleOpenPdf = () => {

    }

    const handleCheckSubScreen = () => {

    }

    const handleDeleteGridModal = (ID) => {
        // if (IsDeleteAllowed) {
        setGridDeleteID(ID)
        setIsOpenDeleteGrid(true)
        // }
    }
    // const columns = [
    //     {
    //         key: 'EncounterStatus',
    //         name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
    //             iconName={'icon-Icon-material-date-range'} headerName={'Encounter Status'} sortIcon={true} type={'string'} colKey={'EncounterStatus'} data={encounterMenuData} setData={setEncounterMenuData} />),
    //         resizable: true,
    //         renderCell: ({ row }) => {
    //             return (<>{row.EncounterStatus === 'Signed' ?
    //                 <p className='Paid heading font-m ar-status-clm'>Signed</p> :
    //                 row.EncounterStatus === 'In Progress' ?
    //                     <p className='In-Review heading font-m ar-status-clm'>In Progress</p> :
    //                     row.EncounterStatus === 'Ready for Review' ?
    //                         <p className='Blue-Status heading font-m ar-status-clm'>Ready for Review</p> :
    //                         ['Unsigned', 'UnSigned'].includes(row.EncounterStatus) &&
    //                         <p className='Not-Signed heading font-m ar-status-clm'>Unsigned</p>}</>)
    //         },
    //     },
    //     {
    //         key: 'DOS',
    //         name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
    //             iconName={'icon-Icon-material-date-range'} headerName={'DOS'} sortIcon={true} type={'date'} colKey={'DOS'} data={encounterMenuData} setData={setEncounterMenuData} />),
    //         resizable: true,
    //         renderCell({ row }) {
    //             return (
    //                 <>
    //                     <button className="btn btn-link w-100" onClick={() => OpenEncounterMenu(row)}>
    //                         {row.DOS}
    //                     </button>
    //                 </>
    //             );
    //         },
    //     },
    //     {
    //         key: 'Patient',
    //         name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
    //             iconName={'icon-Icon-material-date-range'} headerName={'Patient'} sortIcon={true} type={'string'} colKey={'Patient'} data={encounterMenuData} setData={setEncounterMenuData} />),
    //         resizable: true,
    //     },
    //     {
    //         key: 'Provider',
    //         name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
    //             iconName={'icon-Icon-material-date-range'} headerName={'Provider'} sortIcon={true} type={'string'} colKey={'Provider'} data={encounterMenuData} setData={setEncounterMenuData} />),
    //         resizable: true,
    //     },
    //     {
    //         key: 'LocationName',
    //         name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
    //             iconName={'icon-Icon-material-date-range'} headerName={'Location'} sortIcon={true} type={'string'} colKey={'LocationName'} data={encounterMenuData} setData={setEncounterMenuData} />),
    //         resizable: true,
    //     },
    //     {
    //         key: 'Insurance',
    //         name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
    //             iconName={'icon-Icon-material-date-range'} headerName={'Insurance'} sortIcon={true} type={'string'} colKey={'Insurance'} data={encounterMenuData} setData={setEncounterMenuData} />),
    //         resizable: true,
    //     },
    //     {
    //         key: 'NoteType',
    //         name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
    //             iconName={'icon-Icon-material-date-range'} headerName={'Note Type'} sortIcon={true} type={'string'} colKey={'NoteType'} data={encounterMenuData} setData={setEncounterMenuData} />),
    //         resizable: true,
    //     },
    //     // {
    //     //     key: 'AppointmentMode',
    //     //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
    //     //         iconName={'icon-Icon-material-date-range'} headerName={'Appointment Mode'} sortIcon={true} type={'string'} colKey={'AppointmentMode'} data={encounterMenuData} setData={setEncounterMenuData} />),
    //     //     resizable: true,
    //     // },
    //     {
    //         key: 'Actions ',
    //         name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
    //             iconName={'icon-Icon-material-date-range'} headerName={'Actions'} sortIcon={true} type={'string'} colKey={'Actions'} data={encounterMenuData} setData={setEncounterMenuData} />),
    //         resizable: true,
    //         width: 80,
    //         minWidth: 80,
    //         renderCell: ({ row }) => {
    //             return (
    //                 <div className="d-flex gap-1 align-itemes-center justify-content-center w-100">
    //                     {row.IsEncounterSigned === "true" ?
    //                         (row.EncounterStatus !== "Signed" ? <div className="itemList__item" onClick={(e) => handleEncounterAction(e, row, 'Sign')}>Sign</div> : <></>) : <></>}

    //                     {row.IsSuperBillCreated === "true" ? <div className="itemList__item" onClick={(e) => handleEncounterAction(e, row, 'Add Superbill')}>Add Superbill</div> : <></>}
    //                     {row.IsClaimCreated === "true" ? <div className="itemList__item" onClick={(e) => handleCreateClaim(e, row)}>Create Claim</div> : <></>}
    //                     {row.IsClaimView === "true" ?
    //                         ((row.ClaimID && row.ClaimType) ?
    //                             <div className="itemList__item" onClick={(e) => handleViewClaim(e, row)}>View Claim</div> : <></>) : <></>}
    //                     {row.EncounterStatus !== "Signed" ? <i className="icon-delete text-danger" onClick={() => handleDeleteGridModal(row?.EncounterID)}></i> : <></>}
    //                 </div>
    //             );
    //         },
    //     },
    // ];

    const columnsTable = [
        {
            key: "EncounterStatus",
            name: (
                <GridColumnHeader
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                    headerName={"Status"}
                    sortIcon={true}
                    type={"string"}
                    colKey={"EncounterStatus"}
                    data={encounterMenuData}
                    setData={setEncounterMenuData}
                />
            ),
        },
        {
            key: "DOS",
            name: (
                <GridColumnHeader
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                    headerName={"DOS"}
                    sortIcon={true}
                    type={"date"}
                    colKey={"DOS"}
                    data={encounterMenuData}
                    setData={setEncounterMenuData}
                />
            ),
        },
        {
            key: "Patient",
            name: (
                <GridColumnHeader
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                    headerName={"Patient"}
                    sortIcon={true}
                    type={"string"}
                    colKey={"Patient"}
                    data={encounterMenuData}
                    setData={setEncounterMenuData}
                />
            ),
        },
        {
            key: "AccountNumber",
            name: (
                <GridColumnHeader
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                    headerName={"Account #"}
                    sortIcon={true}
                    type={"number"}
                    colKey={"AccountNumber"}
                    data={encounterMenuData}
                    setData={setEncounterMenuData}
                />
            ),
        },
        {
            key: "Provider",
            name: (
                <GridColumnHeader
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                    headerName={"Provider"}
                    sortIcon={true}
                    type={"string"}
                    colKey={"Provider"}
                    data={encounterMenuData}
                    setData={setEncounterMenuData}
                />
            ),
        },
        {
            key: "NoteType",
            name: (
                <GridColumnHeader
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                    headerName={"Note"}
                    sortIcon={true}
                    type={"string"}
                    colKey={"NoteType"}
                    data={encounterMenuData}
                    setData={setEncounterMenuData}
                />
            ),
        },
        {
            key: "AdditionalNotes",
            name: (
                <GridColumnHeader
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                    headerName={"Additional Notes"}
                    sortIcon={true}
                    type={"string"}
                    colKey={"AdditionalNotes"}
                    data={encounterMenuData}
                    setData={setEncounterMenuData}
                />
            ),
        },
        {
            key: "EncounterType",
            name: (
                <GridColumnHeader
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                    headerName={"Encounter Type"}
                    sortIcon={true}
                    type={"string"}
                    colKey={"EncounterType"}
                    data={encounterMenuData}
                    setData={setEncounterMenuData}
                />
            ),
        },
        {
            key: "LocationName",
            name: (
                <GridColumnHeader
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                    headerName={"Location"}
                    sortIcon={true}
                    type={"string"}
                    colKey={"LocationName"}
                    data={encounterMenuData}
                    setData={setEncounterMenuData}
                />
            ),
        },
        {
            key: "Insurance",
            name: (
                <GridColumnHeader
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                    headerName={"Insurance"}
                    sortIcon={true}
                    type={"string"}
                    colKey={"Insurance"}
                    data={encounterMenuData}
                    setData={setEncounterMenuData}
                />
            ),
        },
        {
            key: "EnteredDate",
            name: (
                <GridColumnHeader
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                    headerName={"Entry"}
                    sortIcon={true}
                    type={"string"}
                    colKey={"EnteredDate"}
                    data={encounterMenuData}
                    setData={setEncounterMenuData}
                />
            ),
        },
        // {
        //     key: "AppointmentMode",
        //     name: (
        //         <GridColumnHeader
        //             gridHeader={gridHeader}
        //             handleGridHeader={handleGridHeader}
        //             headerName={"Appointment Mode"}
        //             sortIcon={true}
        //             type={"string"}
        //             colKey={"AppointmentMode"}
        //             data={encounterMenuData}
        //             setData={setEncounterMenuData}
        //         />
        //     ),
        // },
        {
            key: "Actions",
            name: (
                <GridColumnHeader
                    gridHeader={gridHeader}
                    handleGridHeader={handleGridHeader}
                    headerName={"Actions"}
                    sortIcon={false}
                    type={"string"}
                    colKey={"Actions"}
                    data={encounterMenuData}
                    setData={setEncounterMenuData}
                />
            ),
        },
    ];

    const cols = useMemo(() => {
        const valsExist = {
            'AdditionalNotes': encounterMenuData.some(item => item.AdditionalNotes),
        };
        return columnsTable.filter(item =>
            !['AdditionalNotes'].includes(item.key) || valsExist[item.key]
        );

    }, [columnsTable, encounterMenuData]);
    const additionalNotesColExists = cols?.some(item => item?.key === "AdditionalNotes");
    // const AllColumnsName = HandleSelectColumnName(columns);
    const AllColumnsName = HandleSelectColumnName(columnsTable);

    ////Search Letters////
    // const handleSearchByAlphabet = (e) => {
    //     setSearchParam({
    //         SearchLetter: e, SearchCeriteria: "", InsuranceID: null, LocationID: null,
    //         ProviderID: null, Date: null
    //     })
    //     setSearchLoad(searchLoad => !searchLoad)
    // }
    // const handleNextAlphabet = () => {
    //     if (searchParam.SearchLetter === 'Z') {
    //         setSearchParam({ ...searchParam, SearchLetter: 'A' })
    //     } else {
    //         setSearchParam({ ...searchParam, SearchLetter: String.fromCharCode(searchParam.SearchLetter.charCodeAt(0) + 1) });
    //     }
    //     setSearchLoad(searchLoad => !searchLoad)
    // }
    // const handlePreviousAlphabet = () => {
    //     if (searchParam.SearchLetter === 'A') {
    //         setSearchParam({ ...searchParam, SearchLetter: 'Z' });
    //     } else {
    //         setSearchParam({ ...searchParam, SearchLetter: String.fromCharCode(searchParam.SearchLetter.charCodeAt(0) - 1) });
    //     }
    //     setSearchLoad(searchLoad => !searchLoad)
    // }
    const clearFilter = () => {
        setIsFilterApplied(false);
        setInitialProviderData([]);
        setStatusDefault([]);
        setDateRange(null);
        setDateType('');
        setReloadSuperSearch(!reloadSuperSearch)
        setSearchParam({
            ...Search_Data, EntryDateFrom: '', EntryDateTo: ''
        })
        setSearchValue(SearchValue_Data);
        // setselectCoordinator('')
        setSelectedInsurance('')
        setSelectedProvider('')
        setSelectLocation('')
        setFilterShow(false)
        setClear(true)
        handleResetBulkSign();
    }
    const rowClass = (row, rowIdx) => {
        let classes = "row-bg";
        const lastRowsCount = 3;
        if (rowIdx > 15) {
            if (rowIdx >= encounterMenuData.length - lastRowsCount) {
                classes += " last-row";
            }
        }

        return classes;
    };
    const [is, setIs] = useState(false);

    const columnsAll = [
        { key: 'Account', name: 'Account #' },
        { key: 'Name', name: 'Name' },
        { key: 'DOB', name: 'Date of Birth' },
        { key: 'Insured', name: 'Insured' },
        { key: 'BalanceDuePat', name: 'Balance due Pat.' },
        { key: 'AccountPhone', name: 'Account Phone' },
    ]

    const rowsAll = [
        { "Account": "3129831298", "Name": "Alex", "DOB": "04/19/2017", "Insured": "", "BalanceDuePat": "1234", "AccountPhone": "1234567890" },
    ]

    const patientHeader = () => {
        return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '15px' }}>Encounter Menu Search</p>;
    };
    const StatusOption = [
        { value: "Active", display: "Active" },
        { value: "Hold", display: "Hold" },
        { value: "Discharged", display: "Discharged" },
    ]
    const closeDropdown = () => {
        setFilterShow(false);
        setActiveRowId(null);
        setShowContextMenu(false);
    };
    const handleShowContextMenu = (e) => {
        e.stopPropagation();
        setShowContextMenu(true);
    };
    const handleFilterOpen = (e) => {
        setFilterShow(!filterShow)
        e.stopPropagation();

    }
    const handleSelectedData = (selectedData, name, type) => {
        console.log(selectedData);
        if (type === 'client' && !isNull(selectedData)) {
            if (name === "InsuranceID" && !isNull(selectedData)) {
                setSearchParam({ ...searchParam, SearchLetter: null, InsuranceID: selectedData.value + "" });
                setSelectedInsurance(selectedData.display);
            }
            if (name === "CoordinatorID" && !isNull(selectedData)) {
                // setSearchParam({ ...searchParam, SearchLetter: null, CoordinatorID: selectedData.value + "" });
                // setselectCoordinator(selectedData.display);
            }
            if (name === "ProviderID" && !isNull(selectedData)) {
                // setProviderID(selectedData.value + "")
                setSearchParam({ ...searchParam, SearchLetter: null, ProviderID: selectedData.value + "" });
                setSelectedProvider(selectedData.display)
            }
            if (name === "LocationID" && !isNull(selectedData)) {
                // setProviderID(selectedData.value + "")
                setSearchParam({ ...searchParam, SearchLetter: null, LocationID: selectedData.value + "" });
                setSelectLocation(selectedData.display)
            }
            if (name === "RefProviderID" && !isNull(selectedData)) {
                // setRefProviderID(selectedData.value + "")
            }
            if (name === 'NoteType') {
                setSearchParam({ ...searchParam, NoteType: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, NoteType: selectedData.display + "" }))
            }
            if (name === 'EncounterType') {
                setSearchParam({ ...searchParam, EncounterType: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, EncounterType: selectedData.display + "" }))
            }
            if (name === 'EncounterMode') {
                setSearchParam({ ...searchParam, EncounterMode: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, EncounterMode: selectedData.display + "" }))
            }
            if (name === 'EncounterStatus') {
                setSearchParam({ ...searchParam, EncounterStatus: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, EncounterStatus: selectedData.display + "" }))
            }
        } else if (type === 'server' && !isNull(selectedData)) {

        } else {

        }

        return selectedData
    }
    const handleMUltiSelectedData = (selectedDataArray, type, name) => {
        console.log("selectedDataArray", selectedDataArray)
        let modal = { ...searchParam };
        if (type === 'server' && selectedDataArray.length > 0) {
            const displayValues = selectedDataArray.map(data => data.display);
            const valueValues = selectedDataArray.map(data => data.value);
            modal[name] = displayValues.join(', ');
            // PatientSaveUpdateModal[name] = valueValues.join(', ');
        } else if (type === 'client' && selectedDataArray.length > 0) {
            const displayValues = selectedDataArray.map(data => data.display);
            const valueValues = selectedDataArray.map(data => data.value);
            let joinvlues = valueValues.join(', ');
            modal[name] = valueValues.join(', ');
            if (name === "InsuranceID" && !isNull(selectedDataArray)) {
                setSelectedInsurance(joinvlues);
            }
        }
        else {
            console.log("selectedDataArray");
            modal[name] = '';
            // PatientSaveUpdateModal[name] = '';
        }
        setSearchParam(modal);
        // setPatientSaveUpdateModal(PatientSaveUpdateModal);
        return selectedDataArray;
    }
    const handleChange = (e) => {
        let { name, value } = e.target
        // setSearchParam({ ...searchParam, SearchLetter: null, name: value || null })
        if (name === 'InsuranceID') {
            setSelectedInsurance(value)
        } else if (name === 'CoordinatorID') {
            // setselectCoordinator(value)
        }
        else if (name === 'ProviderID') {
            setSelectedProvider(value)
        }
        else if (name === 'LocationID') {
            setSelectLocation(value)
        }
    }
    const handleSubActiveMenu = (e, ID) => {
        e.stopPropagation();
        setActiveRowId(ID);
        setSubMenuActive(!subMenuActive)
    };

    const handleEncounterAction = (e, row, scrollTo) => {
        e.stopPropagation();
        if (scrollTo === 'Sign') {
            if (!isSignEditAllowed) return;
        }
        if (scrollTo === 'Add Superbill') {
            if (!isSuperbillEditAllowed) return;
        }


        let obj = {
            active: true,
            key: 2,
            name: "Encounter Menu",
            data: {
                name: `${row.DOS}`,
                id: row.EncounterID,
                patid: row.PatientID,
                scrollTo: scrollTo,
                type: row.NoteType,
                time: new Date()
            },
        }
        props.TabActionEncounterMenu(obj);
    }
    // const handleCreateClaim = (e, row) => {
    //     e.stopPropagation();
    //     let dataObj = {
    //         key: 2,
    //         name: "Claims",
    //         active: true,
    //         data: {
    //             name: "New Professional",
    //             id: -1,
    //             time: new Date(),
    //             visitType: "P",
    //             EncounterID: row?.EncounterID
    //         },
    //     };
    //     setOpenTab(dataObj)
    // }

    const handleCreateClaim = (e, row) => {
        e.stopPropagation();
        if (!isCreateClaimEditAllowed) return;

        let dataForClaim = {
            EncounterID: row?.EncounterID,
            PatientID: row?.PatientID,
            PatientName: row?.Patient,
        }
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "New Professional",
                id: -1,
                time: new Date(),
                visitType: "P",
                EncounterID: dataForClaim
            },
        };
        setOpenTab(dataObj)
    }

    const handleViewClaim = (e, row) => {
        if (!isClaimViewAllowed) return;
        let obj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                id: row.ClaimID,
                name: row.Patient,
                time: new Date(),
                visitType: row?.ClaimType,
                EncounterID: row?.EncounterID,
                PatientID: row?.PatientID,
            },
        };
        setOpenTab(obj)
    }
    const lastRowClass = () => {
    };

    useEffect(() => {
        if (!del) return;
        // setIs(true);

        let encExist = OpenedEncounters?.find(enc => (enc.data.id == gridDeleteID));
        if (encExist) {
            props.TabActionEncounterMenu({}, gridDeleteID);
        }
        LoadData(searchParam);
    }, [del])

    // add new encounter from appointment
    useEffect(() => {
        if (AddNewEncounter?.data?.openedFor === 'New Encounter') {
            handleAddNewEncounter();
        } else if (AddNewEncounter?.data?.openedFor === 'New AI Encounter') {
            handleOpenAIEncounter()
        }
    }, [AddNewEncounter])
    ////Reload on Save
    useEffect(() => {
        if (reloadGrid?.EncounterMenuSearch === true) {
            LoadData(searchParam);
            dispatch(ReloadGridAction({ EncounterMenuSearch: false }));
        }
    }, [reloadGrid?.EncounterMenuSearch])


    const onCloseDeleteGrid = () => {
        setDel(true);
        setIsOpenDeleteGrid(false)
    }
    const onCloseGrid = () => {
        setIsOpenDeleteGrid(false)
    }
    let DeleteConfirmationGrid = "";
    if (isOpenDeleteGrid) {
        DeleteConfirmationGrid = <DeleteConfirmatiom isOpenAlert={isOpenDeleteGrid} onCloseDelete={onCloseGrid} API_URL={API_URL_GENERAL} TableName={enumUtil.enumAPITableName.Encounter} ID={gridDeleteID} onClose={onCloseDeleteGrid} Messsage={true} hideReason={true} />
    }

    const [editedIds, setEditedIds] = useState(new Set());
    const [selectAllStatus, setSelectAllStatus] = useState(null);

    const handleStatusChange = (rowIndex, value) => {
        setEncounterMenuData(prev => {
            const newData = [...prev];
            newData[rowIndex] = {
                ...newData[rowIndex],
                EncounterStatus: value
            };
            return newData;
        });
        setEditedIds(prev => new Set(prev.add(encounterMenuData[rowIndex].ID)));
        setSelectAllStatus(null);
    };

    const handleEncounterStatusSave = (value, EncounterID) => {

        let saveModal = {
            "TableName": enumUtil.enumAPITableName.OtherNote,
            "ID": EncounterID,
            "Data": {
                "EncounterStatus": value
            }
        }

        setIsLoading(true);
        ServerRequestProtected(API_URL_GENERAL + '/SaveSingleRecord', "post", saveModal)
            .then((response) => {
                setIsLoading(false);
                if (!isNull(response)) {
                    NotificationHandler("Record Saved Successfully", enumUtil.enumtoaster.success);
                    LoadData(searchParam)
                }
            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
            })
    }

    const handleSelectedDataEncounterStatusChange = (selectedData, name, type, index, currentRecord, listIndex, EncounterID) => {

        if (selectedData?.display === currentRecord) {
            return;
        }
        // listIndex
        let StatusName = selectedData?.display;
        let StatusValue = selectedData?.value;

        setEncounterMenuData(prev => {
            const newData = [...prev];
            newData[listIndex] = {
                ...newData[listIndex],
                EncounterStatus: StatusName
            };
            return newData;
        });

        handleEncounterStatusSave(StatusValue, EncounterID)
    }
    // only include selectable rows
    // const getSelectableRowIds = (data, isSignEditAllowed) =>
    //     data
    //         .filter(row => row.EncounterStatus !== "Signed" && isSignEditAllowed)
    //         .map(row => row.EncounterID);

    const getSelectableRowIds = (data, isSignEditAllowed, isViewAllowed) => {
        return data
            .filter(row => {
                if (typeCheckBox === 'BulkSign') {
                    // Can select only if not signed and editing is allowed // is Allowed to Sign (right)
                    return (row.EncounterStatus !== "Signed" && isSignEditAllowed && row?.isSignatureAllowed === "true")
                } else if (typeCheckBox === 'BulkPrint') {
                    // Can select only if viewing is allowed
                    return isViewAllowed;
                } else if (typeCheckBox === 'BulkClaim') {
                    return (row.IsClaimCreated === "true" && isCreateClaimEditAllowed);
                }
                return false; // default fallback
            })
            .map(row => row.EncounterID);
    };
    //  useMemo so it doesn't recalculate every render
    const selectableRowIds = useMemo(
        () => getSelectableRowIds(encounterMenuData, isSignEditAllowed, isViewAllowed),
        [encounterMenuData, isSignEditAllowed, isViewAllowed, typeCheckBox]
    );

    //  "Select All" checked state
    const isAllSelected =
        selectedRows.size > 0 &&
        selectableRowIds.length > 0 &&
        selectableRowIds.every(id => selectedRows.has(id));

    //  "Select All" handler
    const onSelectAllChange = (checked) => {
        if (checked) {
            setSelectedRows(new Set(selectableRowIds));
            setSelectedEncounterIDs(selectableRowIds.join(", "));
        } else {
            setSelectedRows(new Set());
            setSelectedEncounterIDs("");
        }
    };

    //  Individual checkbox handler
    const onRowSelection = (id, checked) => {
        const updatedSet = new Set(selectedRows);
        if (checked) {
            updatedSet.add(id);
        } else {
            updatedSet.delete(id);
        }
        setSelectedRows(updatedSet);
        setSelectedEncounterIDs([...updatedSet].join(", "));
    };

    const [isOpenBulkClaim, setIsOpenBulkClaim] = useState(false);
    const enableButton = (type) => {
        return (isNull(typeCheckBox) || typeCheckBox === type);
    }
    const hanldeOpenBulkPrint = () => {
        if (!isViewAllowed || (typeCheckBox && typeCheckBox !== 'BulkPrint')) return;

        setCheckBoxShow(true);
        if (!checkBoxShow) {
            setTypeCheckBox('BulkPrint');
        }

        if (selectedEncounterIDs?.length > 0) {
            setIsOpenBulkPrint(true)
        }
        if (selectedEncounterIDs?.length === 0 && checkBoxShow) {
            NotificationHandler('Please Select Row', enumUtil.enumtoaster.warning)
        }
    }
    const [appliedBulkClaimData, setAppliedBulkClaimData] = useState([])

    const applyBulkClaim = (encounterIDs) => {
        setIsLoading(true);
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.CreateBulkClaimByEncounter,
            "Data": {
                "EncounterIDs": encounterIDs
            }
        };
        setAppliedBulkClaimData([])
        ServerRequestProtected(API_URL_PatientEncounter + '/BulkClaimByEncounter', "post", saveModal)
            .then((response) => {
                setIsLoading(false);
                if (!isNull(response)) {
                    // NotificationHandler("Bulk claim created successfully.", enumUtil.enumtoaster.success);
                    setAppliedBulkClaimData(response)
                    setIsOpenBulkClaim(true)
                }
            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
            })
    };
    const hanldeOpenBulkClaim = () => {
        if (!isViewAllowed || !isCreateClaimEditAllowed || (typeCheckBox && typeCheckBox !== 'BulkClaim')) return;

        setCheckBoxShow(true);
        if (!checkBoxShow) {
            setTypeCheckBox('BulkClaim');
        }
        if (selectedEncounterIDs?.length > 0) {
            console.log("selectedEncounterIDs", selectedEncounterIDs)
            applyBulkClaim(selectedEncounterIDs);
        }
        if (selectedEncounterIDs?.length === 0 && checkBoxShow) {
            NotificationHandler('Please Select Row', enumUtil.enumtoaster.warning)
        }
    }
    const handleCloseBulkClaim = () => {
        setIsOpenBulkClaim(false);
        setAppliedBulkClaimData([]);
        handleResetBulkSign();
        dispatch(ReloadGridAction({ EncounterMenuSearch: true }));
    }

    const hanldeOpenBulkSign = () => {
        if (!isSignEditAllowed || (typeCheckBox && typeCheckBox !== 'BulkSign')) return;

        setCheckBoxShow(true);
        if (!checkBoxShow) {
            setTypeCheckBox('BulkSign');
        }

        if (selectedEncounterIDs?.length > 0) {
            const selectedEncounters = encounterMenuData.filter(enc => selectedEncounterIDs?.split(',')
                .map(id => id.trim()).includes(String(enc.EncounterID)));
            let providerSet = new Set(selectedEncounters.flatMap(it => it.UserProviderID));
            // let providerSignSet = new Set(selectedEncounters.flatMap(it => it.ProviderSignaturePath));
            // console.log("providerSignSet", providerSet, providerSignSet, selectedEncounters.length)
            if (providerSet.size > 1 && checkBoxShow) {
                NotificationHandler('Encounters from different providers cannot be selected together. Please select encounters belonging to the same provider.', enumUtil.enumtoaster.warning)
                return;
            }
            if (providerSet.has(undefined)) {
                return;
            }
            setSignatureSearchParam({
                "EncounterIDs": selectedEncounterIDs,
                "ProviderID": providerSet.values().next().value,
                "SignaturePath": userSignData.ProviderSignaturePath,
                "SignatureFileName": userSignData.ProviderSignatureFileName,
            })
            setIsOpenBulkSignature(true)
        }
        if (selectedEncounterIDs?.length === 0 && checkBoxShow) {
            NotificationHandler('Please Select Row', enumUtil.enumtoaster.warning)
        }
    }
    const handleResetBulkSign = () => {
        setCheckBoxShow(false);
        setSelectedRows((new Set()));
        setSelectedEncounterIDs([]);
        setIsOpenBulkSignature(false);
        setIsOpenBulkPrint(false);
        setSignatureSearchParam({});
        setTypeCheckBox('');
    }

    /////////////////////////////

    const getSaveData = (a, fileName, fileContent, signStatus) => {
        const updateUserData = () => signStatus !== "SignExists" && handleLoadUserData();
        const updatedSignatureSearchParam = {
            ...signatureSearchParam,
            // EncounterStatus: "Signed",
            ...(signStatus !== "SignExists" && {
                SignaturePath: fileContent,
                SignatureFileName: fileName,
            }),
        };
        setSignatureSearchParam(updatedSignatureSearchParam);

        let saveModal = {
            "TableName": enumUtil.enumAPITableName.SignEncounterInBulk,
            "Data": updatedSignatureSearchParam
        }
        ServerRequestProtected(API_URL_PatientEncounter + '/BulkSignEncounter', "post", saveModal)
            .then((response) => {
                setIsLoading(false);
                if (!isNull(response)) {
                    NotificationHandler("Record Signed Successfully", enumUtil.enumtoaster.success);
                    updateUserData() // to set latest user in redux if updated
                    LoadData(searchParam)
                }
            }).catch((error) => {
                setIsLoading(false);
                NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
            }).finally(() => {
                handleResetBulkSign();
            })
    }
    let BulkSignaturePopup = ""
    if (isOpenBulkSignature) {
        BulkSignaturePopup = <SignatureBulk isOpenBulkSignature={isOpenBulkSignature} setIsOpenBulkSignature={setIsOpenBulkSignature} handleResetBulkSign={handleResetBulkSign} selectedEncounterIDs={selectedEncounterIDs}
            //  setBulkSignatureParam={setBulkSignatureParam} 
            encounterMenuData={encounterMenuData} type="EncounterMenu" isOpenedFrom={"EncounterMenuBulk"} getSaveData={getSaveData} setSearchParam={setSignatureSearchParam} userSignData={userSignData} />
    }
    /////////////// Add New Encounter ////////////////////
    const [openNewEncounterPopup, setOpenNewEncounterPopup] = useState(false);
    const [isAiEncounter, setIsAiEncounter] = useState(false);
    const [selectedOption, setSelectedOption] = useState("SelectAppointment");

    const hasReachedEncounterTabLimit = () => {
        return ((OpenedEncounters?.length ?? 0) >= 5);
    }

    const handleAddNewEncounter = (openedFrom) => {
        if (!IsEditAllowed) return;
        // if (patientID && patientID !== PatientIDR) return;
        if (hasReachedEncounterTabLimit()) {
            closeDropdown();
            NotificationHandler('Sorry! You can add maximum 5', 'success');
            return;
        }
        setOpenNewEncounterPopup(true);
        setIsAiEncounter(false)
        if (selectedOption === "SelectDate") {
            // handleApplyDemoData();
        }
        // if (openedFrom === 'Clear_Add_Encounter_Popup') {
        //     dispatch({
        //         type: 'Clear_Add_Encounter_Popup',
        //         payload: {
        //             patientId: PatientIDR,
        //             encounterId: 0 // Assuming you're always opening on "All Encounter"
        //         }
        //     });
        // }
        // }
    }
    const handleOpenAIEncounter = () => {
        if (!IsEditAllowed) return;

        if (hasReachedEncounterTabLimit()) {
            closeDropdown();
            NotificationHandler('Sorry! You can add maximum 5', 'success');
            return;
        }
        setIsAiEncounter(true)
        setOpenNewEncounterPopup(true);
    }

    return (
        <>
            {encounterMenuData?.length > 0 ?
                <PrintBulkEncounter isOpenBulkPrint={isOpenBulkPrint} setIsOpenBulkPrint={setIsOpenBulkPrint} handleResetBulkSign={handleResetBulkSign} selectedEncounterIDs={selectedEncounterIDs} encounterMenuData={encounterMenuData} type="EncounterMenu" isOpenedFrom={"EncounterMenuBulk"} // getSaveData={getSaveData} //setSearchParam={setSignatureSearchParam}
                /> : <></>}
            {BulkSignaturePopup}
            {DeleteConfirmationGrid}
            {popup}
            {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}
            <AddNewPatientEncounter key={isAiEncounter} IsEditAllowed={IsEditAllowed} openNewEncounterPopup={openNewEncounterPopup} setOpenNewEncounterPopup={setOpenNewEncounterPopup} setIsAiEncounter={setIsAiEncounter} isAiEncounter={isAiEncounter} selectedOption={selectedOption} setSelectedOption={setSelectedOption} TabActionEncounterMenu={props.TabActionEncounterMenu} AddNewEncounter={AddNewEncounter} />

            <Modal
                show={isOpenBulkClaim}
                onHide={handleCloseBulkClaim}
                backdrop="static"
                keyboard={false}
                centered
                dialogClassName="hk-modal-v1 mw-1000px"
            >
                <Modal.Body>
                    <div className="d-flex align-items-center justify-content-between mb-12">
                        <p className="heading dark-clr fs-14">Result</p>
                        <i className="icon-x-cros fs-20 dark-clr" onClick={handleCloseBulkClaim}></i>
                    </div>

                    <div className="hk-expand-table overflow-auto BorderLess-table">
                        <table className="w-100">
                            <thead>
                                <tr>
                                    <th>Encounter #</th>
                                    <th>Patient Name</th>
                                    <th>Provider</th>
                                    <th>Location</th>
                                    <th>Insurance</th>
                                    <th>Claim #</th>
                                    <th>Status</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {appliedBulkClaimData.length > 0 ? (
                                    appliedBulkClaimData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.EncounterID}</td>
                                            <td>{item.PatientName}</td>
                                            <td>{item.Provider}</td>
                                            <td>{item.Location}</td>
                                            <td>{item.Insurance}</td>
                                            <td>{item.ClaimID}</td>
                                            <td><HandleStatus Status={item?.BillingStatus} RejectionReason={item?.MsgStatus} /></td>
                                            <td>{item.Remarks}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center">
                                            No Data Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className={"btn btn-validate px-10 h-100"} onClick={handleCloseBulkClaim}>
                        Close
                    </button>
                </div>
            </Modal>

            {/* <div className='p-2 pt-1 pb-0'>
                <div className='alphabetic-filter m-auto'>
                    <button className='refresh active'>
                        <i className="icon-Icon-awesome-sync-alt" onClick={() => handleSearchByAlphabet(null)}></i>
                    </button>
                    <button>
                        <i className='icon-angle-left' onClick={handlePreviousAlphabet}></i>
                    </button>
                    <div className='alphabetics'>
                        {Alphbets.map((type) => {
                            return (
                                <span className={type.value === searchParam.SearchLetter ? 'active' : ''} onClick={() => handleSearchByAlphabet(type.value)} key={type.value}>{type.value}</span>
                            )
                        })}
                    </div>
                    <button>
                        <i className='icon-right-direction' onClick={handleNextAlphabet}></i>
                    </button>
                </div>
            </div> */}
            <div className="container-fluid py-2">
                <div className="row row-half hk-opt-bar row-gap-5">
                    <div className="col-md-3 multipleSearch-rounded rounded-full agency-pat-search">
                        <div className="input autocomplete-group autocomplete-group-xs">
                            <label htmlFor="" className="hs-patient-label">Patient</label>
                            <div className='input-group'>
                                <SuperSearchMultipleServer
                                    key={reloadSuperSearch}
                                    id="Search"
                                    name="Search"
                                    SuperSearchView="DetailedView"
                                    DetailedView="Patient"
                                    initialSelectedOptionsInstant={patientValue}
                                    searchParam={searchParam}
                                    setSearchParam={setSearchParam}
                                    tableName={enumUtil.enumAPITableName.Patient}
                                    controller={API_URL_Patient}
                                    ApiLink={"/InstantSearchWithDetails"} //api url 
                                    method='post'  //   api method
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="input filters-field multipleSearch-rounded">
                            <div className="input">
                                <label htmlFor="" className="hs-patient-label">Provider</label>
                                <SuperSearchMultipleClient
                                    key={reloadSuperSearch}
                                    id="ProviderID"
                                    name="ProviderID"
                                    selectedOptionsDisplay='Provider'
                                    initialSelectedValues={initialProviderData || []}
                                    // initialSelectedValues={[]}
                                    searchParam={searchParam}
                                    setSearchParam={setSearchParam}
                                    options={DropdownData.Provider?.filter(item => !['-1', -1].includes(item.value))}
                                    onSelect={handleMUltiSelectedData}
                                    sup_btn="sup_btn-Inp"
                                    sup_inp="superSearchVisitInp"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2 select-bg-img-1">
                        <div className="input multipleSearch-rounded">
                            <label className="hs-patient-label">Location</label>
                            <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="LocationID"
                                name="LocationID"
                                selectedOptionsDisplay='LocationID'
                                // initialSelectedValues={locationDefault}
                                initialSelectedValues={[]}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                options={DropdownData?.Location?.filter(item => !['-1', -1].includes(item.value))}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                    </div>
                    <div className="col-md-2 multipleSearch-rounded">
                        <div className='input simple_select position-relative'>
                            <label className="hs-patient-label">Insurance</label>
                            <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="InsuranceID"
                                name="InsuranceID"
                                selectedOptionsDisplay='Insurance'
                                initialSelectedValues={[]}
                                options={DropdownData.Insurance?.filter(item => !['-1', -1].includes(item.value))}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <CalendaRangeInput
                            key={reloadSuperSearch}
                            searchParam={searchParam} setSearchParam={setSearchParam} options={['DOS', 'Entry Date']} defaultDates={dateRange}
                            DateType={dateType} SetDateType={setDateType}
                        />
                    </div>
                    <div className='col-md-3 multipleSearch-rounded'>
                        <div className={`input form-group ar-multiple-br m-0 w-100`}>
                            <label className="hs-patient-label">Encounter Type</label>
                            {/* <SuperSearchList
                                type="client"
                                id='EncounterType'
                                name='EncounterType'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValue.EncounterType}
                                data={visitTypes}
                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, EncounterType: e.target.value }) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                                placeholder={false}
                            /> */}
                            <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="EncounterType"
                                name="EncounterType"
                                selectedOptionsDisplay='Encounter Type'
                                initialSelectedValues={[]}
                                options={visitTypes?.filter(item => !['-1', -1].includes(item.value))}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                    </div>
                    {/* <div className='col-md-2 multipleSearch-rounded'>
                        <div className={`input form-group ar-multiple-br m-0 w-100`}>
                            <label className="hs-patient-label">Encounter Mode</label>
                            {/* <SuperSearchList
                                type="client"
                                id='EncounterMode'
                                name='EncounterMode'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValue.EncounterMode}
                                data={visitTypes}
                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, EncounterMode: e.target.value }) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                                placeholder={false}
                            /> */}
                    {/*  <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="EncounterMode"
                                name="EncounterMode"
                                selectedOptionsDisplay='Encounter Mode'
                                initialSelectedValues={[]}
                                options={encounterModeData?.filter(item => !['-1', -1].includes(item.value))}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                    </div> */}
                    <div className="col-md-2 multipleSearch-rounded">
                        <div className={`input form-group ar-multiple-br m-0 w-100`}>
                            <label className="hs-patient-label">Note Type</label>
                            {/* <SuperSearchList
                                type="client"
                                id='NoteType'
                                name='NoteType'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValue.NoteType}
                                data={noteTypesData}
                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, NoteType: e.target.value }) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                                placeholder={false}
                            /> */}
                            <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="NoteType"
                                name="NoteType"
                                selectedOptionsDisplay='Note Type'
                                initialSelectedValues={[]}
                                options={noteTypesData?.filter(item => !['-1', -1].includes(item.value))}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                    </div>
                    <div className='col-md-2 multipleSearch-rounded'>
                        <div className={`input form-group ar-multiple-br m-0 w-100`}>
                            <label className="hs-patient-label">Encounter Status</label>
                            {/* <SuperSearchList
                                type="client"
                                id='EncounterStatus'
                                name='EncounterStatus'
                                icon={'Simple'}
                                sup_btn='sup_btn'
                                sup_inp='superSearchVisitInp'
                                searchValue={searchValue.EncounterStatus}
                                data={encounterStatusData}
                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, EncounterStatus: e.target.value }) }}
                                getSelectedData={handleSelectedData}
                                is={is}
                                placeholder={false}
                            /> */}

                            <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="EncounterStatus"
                                name="EncounterStatus"
                                selectedOptionsDisplay='Encounter Status'
                                initialSelectedValues={statusDefault}
                                options={encounterStatusData?.filter(item => !['-1', -1].includes(item.value))}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                    </div>
                    <div className="col-md-5 d-flex align-items-end justify-content-between gap-2">
                        <div className="btns-group-flex">
                            <button className={isViewAllowed ? 'btn btn-orange btn-xs no-width rounded' : 'btn btn-orange btn-xs no-width rounded disabled'} onClick={SearchByParam}>Search</button>
                            <div className="line-border"></div>
                            <button className='btn btn-outline btn-xs no-width rounded min-w-0 px-10' onClick={clearFilter}>Clear</button>
                            <div className="line-border"></div>
                            <button className={`btn btn-Signed btn-xs no-width rounded min-w-0 px-10 ${(isSignEditAllowed && enableButton('BulkSign')) ? "" : "disabled"}`} onClick={hanldeOpenBulkSign}>Sign</button>
                            <div className="line-border"></div>
                            <button className={`btn btn-Print btn-xs no-width rounded min-w-0 px-10 ${(isViewAllowed && enableButton('BulkPrint')) ? "" : "disabled"}`} onClick={hanldeOpenBulkPrint}>Print</button>
                            {/* <div className="line-border"></div>
                            <button class={`btn btn-orange btn-xs no-width rounded mb-0 d-flex align-items-center gap-1 ${IsEditAllowed ? "" : 'disable'}``} >
                                <span class="fs-16 heading text-white">+</span>New Encounter
                            </button> */}
                        </div>

                        <div className="position-relative hk-opt-bar d-flex gap-2 no-search-margin">
                            {/* <button className={`btn-icon-circle btn-xs hk-plusWrapper__Btn ${IsEditAllowed ? "" : 'disable'}`} onClick={handleAddNewEncounter}>
                                <i className="fs-15 icon-plus-icon"></i>
                            </button> */}
                            <div className="ar-create-encounter_tooltip">
                                <button class={`btn btn-orange btn-xs no-width rounded mb-0 d-flex align-items-center gap-1 ${IsEditAllowed ? "" : 'disable'}`} onClick={handleShowContextMenu}>
                                    <span class="fs-16 heading text-white">+</span>New Encounter
                                    <i className="icon-caret-down br-left-1 lh-25 ps-1-5"></i>

                                </button>
                                <CustomUseRef onClose={closeDropdown} IsActivePtPayments={showContextMenu} type={'menuButton'} className={'position-static'}>
                                    <div className={`context-menu d-flex flex-column gap-1 left-0 ${showContextMenu && 'Show-context'}`}>
                                        <div className="d-flex align-items-center gap-2 px-2" onClick={handleAddNewEncounter}>
                                            <i className="icon-plus-feesetup fs-11"></i>
                                            <p className='text fs-11 font-m text-nowrap'>Create  Encounter</p>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 px-2">
                                            <i className="icon-ai-encounter fs-14"></i>
                                            <p className='text fs-11 font-m text-nowrap' onClick={handleOpenAIEncounter}>Create AI Encounter</p>
                                        </div>
                                    </div>
                                </CustomUseRef>

                            </div>

                            <div className="br-clr-light br-left-1 ps-1-5 d-flex">
                                <SearchHeader
                                    AddNew={AddNewEncounterMenu}
                                    Filter={handleFilterOpen}
                                    FilterClass={IsFilterApplied}
                                    searchButton={searchButton}
                                    Key={91}
                                    tableName={enumUtil.enumAPITableName.GIRPNote}
                                    Name={'EncounterMenuSearch'}
                                    searchParam={{ ...searchParam, IsExcelExport: "1" }}
                                    PerPage={PerPage}
                                    PageNo={PageNo}
                                    TotalPages={TotalPages}
                                    isEmpty={encounterMenuData.length > 0}
                                    componentColumns={AllColumnsName}
                                    ColumnTableName={'EncounterMenu'}
                                    enabled={SidebarActive === 9}
                                />
                            </div>

                            <button className="btn-icon-transparent claim_submenu lh-10" onClick={handleSubActiveMenu}><i class="icon-dots-menu"></i>
                                {<CustomUseRef onClose={closeDropdown} IsActivePtPayments={subMenuActive}>
                                    {subMenuActive === true ?
                                        <div className='claims-TabHeader__right__submenu right-7 top-100-5 active'>
                                            <div className={`itemList ${(isViewAllowed && enableButton('BulkClaim') && isCreateClaimEditAllowed) ? "" : "disabled"}`}>
                                                <div className="itemList__item" onClick={hanldeOpenBulkClaim}>Bulk Claim</div>
                                            </div>
                                        </div>
                                        : null
                                    }
                                </CustomUseRef>}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            {isLoading ? <Loader /> : null}
            {/* {console.log("encounterDate encounterDate", encounterMenuData)} */}
            <div className="patient_filter position-relative">

                <div className={`hk-expand-table overflow-auto BorderLess-table two-rows-with-tab encounter-menu-table ${((GridView?.GridView === 'Borderless Grid' || GridView?.GridView === 'BorderlessGrid') ? '' : 'BorderTable')}`} >
                    <table className="w-100">
                        <thead>
                            <tr>
                                {checkBoxShow ?
                                    <th className="w-0px">
                                        <div className="custom_check_box text-center">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0"
                                                checked={isAllSelected}
                                                onChange={(e) => onSelectAllChange(e.target.checked)}
                                            />
                                        </div>
                                    </th> : <></>}
                                {cols?.map(col => (
                                    <th className={`${col.key === 'EncounterStatus' ? 'status-col' : ''}`}>
                                        {col.name}
                                    </th>
                                ))}
                            </tr>
                            {/* <tr>
                                <th>
                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        // iconName={'icon-card'}
                                        headerName={'Encounter Status'}
                                        sortIcon={true}
                                        type={'string'}
                                        colKey={'EncounterStatus'}
                                        data={encounterMenuData}
                                        setData={setEncounterMenuData}
                                    />
                                </th>
                                <th>
                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        headerName={'DOS'}
                                        sortIcon={true}
                                        type={'date'}
                                        colKey={'DOS'}
                                        data={encounterMenuData}
                                        setData={setEncounterMenuData}
                                    />
                                </th>
                                <th>
                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        headerName={'Patient'}
                                        sortIcon={true}
                                        type={'string'}
                                        colKey={'Patient'}
                                        data={encounterMenuData}
                                        setData={setEncounterMenuData}
                                    />
                                </th>
                                <th>
                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        headerName={'Provider'}
                                        sortIcon={true}
                                        type={'string'}
                                        colKey={'Provider'}
                                        data={encounterMenuData}
                                        setData={setEncounterMenuData}
                                    />
                                </th>
                                <th>
                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        headerName={'Location'}
                                        sortIcon={true}
                                        type={'string'}
                                        colKey={'LocationName'}
                                        data={encounterMenuData}
                                        setData={setEncounterMenuData}
                                    />
                                </th>
                                <th>
                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        headerName={'Insurance'}
                                        sortIcon={true}
                                        type={'string'}
                                        colKey={'Insurance'}
                                        data={encounterMenuData}
                                        setData={setEncounterMenuData}
                                    />
                                </th>
                                <th>
                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        headerName={'Note Type'}
                                        sortIcon={true}
                                        type={'string'}
                                        colKey={'NoteType'}
                                        data={encounterMenuData}
                                        setData={setEncounterMenuData}
                                    />
                                </th>
                                <th>
                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        headerName={'Appointment Mode'}
                                        sortIcon={true}
                                        type={'string'}
                                        colKey={'AppointmentMode'}
                                        data={encounterMenuData}
                                        setData={setEncounterMenuData}
                                    />
                                </th>
                                <th className="w-0px">
                                    <GridColumnHeader
                                        gridHeader={gridHeader}
                                        handleGridHeader={handleGridHeader}
                                        headerName={'Actions'}
                                        sortIcon={true}
                                        type={'string'}
                                        colKey={'Actions'}
                                        data={encounterMenuData}
                                        setData={setEncounterMenuData}
                                    />
                                </th>
                            </tr> */}
                        </thead>
                        <tbody>
                            {encounterMenuData.length > 0 ? encounterMenuData.map((row, index) => {
                                const isChecked = selectedRows.has(row.EncounterID);
                                const isMainProviderSignatureAllowed = row?.isSignatureAllowed === "true";
                                const isDisabled =
                                    (typeCheckBox === 'BulkSign' && (row.EncounterStatus === "Signed" || !isSignEditAllowed)) ||
                                    (typeCheckBox === 'BulkSign' && (!isMainProviderSignatureAllowed || !isSignEditAllowed)) ||
                                    (typeCheckBox === 'BulkPrint' && !isViewAllowed) ||
                                    (typeCheckBox === 'BulkClaim' && (!(row.IsClaimCreated === "true") || !isCreateClaimEditAllowed))
                                let data = {
                                    name: 'Patient',
                                    data: {
                                        id: row.PatientID,
                                        name: row.Patient,
                                    }
                                };

                                return (<tr key={index}> {/* Use row.id if available instead of index */}

                                    {checkBoxShow ?
                                        <td>
                                            <div className="custom_check_box text-center">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0"
                                                    checked={isChecked}
                                                    disabled={isDisabled}
                                                    onChange={(e) => onRowSelection(row.EncounterID, e.target.checked)}
                                                />
                                            </div>
                                        </td> : <></>}
                                    <td className="meanu-search-status">
                                        {/* <div className="d-flex align-items-center gap-2">
                                            {['E', 'W', 'D'].map((option) => (
                                                <label
                                                    key={option}
                                                    className="ar_radio-btn d-flex align-items-center gap-1"
                                                >
                                                    <input
                                                        type="radio"
                                                        name={`statusPTP-${index}`}
                                                        checked={row.Status === option}
                                                        onChange={() => handleStatusChange(index, option)}
                                                    />
                                                    <span className="text ar-orange-text fs-13">{option}</span>
                                                </label>
                                            ))}
                                        </div> */}

                                        {/* <div className="border-less-input">
                                            <SuperSearchList
                                                type="client"
                                                id='AppointmentStatusID'
                                                name='AppointmentStatusID'
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                                icon={'Simple'}
                                            />
                                        </div> */}
                                        <>{row.EncounterStatus === 'Signed' ?
                                            <p className='Paid heading font-m ar-status-clm w-max-content'>Signed</p> :
                                            <div className="ar-multiple-br appointment position-relative"
                                            // onClick={(e) => handleAppointmentRecord(e, appointment)}
                                            >
                                                <div className="border-less-input">
                                                    <SuperSearchList
                                                        type="client"
                                                        id='EncounterStatus'
                                                        name='EncounterStatus'
                                                        searchValue={row?.EncounterStatus}
                                                        data={encounterStatusDataSave?.filter(item => !['-1', -1].includes(item.value)) || []}
                                                        onChange={() => { }}
                                                        // onChange={() => handleStatusChange(index, option)}
                                                        getSelectedData={(...args) => handleSelectedDataEncounterStatusChange(...args, index, row?.EncounterID)}
                                                        recordID={row?.EncounterStatus}
                                                        sup_btn='sup_btn-Inp'
                                                        sup_inp='superSearchVisitInp'
                                                        icon={'Simple'}
                                                        placeholder={false}
                                                        // Color={true}
                                                        EncounterStatus={true}
                                                        isReadOnly={false}
                                                    />
                                                </div>
                                                {/* <span className="Room_no ar-light-color fs-12 text">{(appointment?.AppointmentStatus === 'In Room' || appointment?.AppointmentStatus === 'Change Room') ? appointment?.Reason : ''}</span> */}

                                            </div>}

                                            {/* {row.EncounterStatus === 'Signed' ?
                                                <p className='Paid heading font-m ar-status-clm'>Signed</p> :
                                                row.EncounterStatus === 'In Progress' ?
                                                    <p className='In-Review heading font-m ar-status-clm'>In Progress</p> :
                                                    row.EncounterStatus === 'Ready for Review' ?
                                                        <p className='Blue-Status heading font-m ar-status-clm'>Ready for Review</p> :
                                                        ['Unsigned', 'UnSigned'].includes(row.EncounterStatus) &&
                                                        <p className='Not-Signed heading font-m ar-status-clm'>Unsigned</p>} */}

                                        </>
                                    </td>
                                    <td>
                                        <p
                                            className="cursor-pointer grid-hover-text text fs-12"
                                            // className={isEditAllowed ? 'cursor-pointer grid-hover-text text fs-12' : 'cursor-pointer grid-hover-text text fs-12 pe-none opacity-40 disabled'}
                                            onClick={() => OpenEncounterMenu(row)}>{row.DOS}</p>
                                    </td>
                                    <td>
                                        {/* <p className="cursor-pointer text fs-12 ar-hover-text" onClick={() => handleOpenNewBrowserTab(data)}>{row.Patient || ''}</p> */}
                                        <div className="d-flex gap-1 align-items-center justify-content-between w-100 table-copy position-relative">

                                            <div className="d-flex align-items-center gap-1 mw-200px">
                                                <div className="copy_icon validation_message ar-hover-text text-nowrap min-w-0 lh-normal" title={row.Patient} onClick={() => handleOpenNewBrowserTab(data)}>{row.Patient}</div>


                                            </div>

                                            {row.Patient && (
                                                <div className="app_tooltip left ar-copy-hover">
                                                    <div className="d-flex">
                                                        <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.EncounterID, row.Patient)} ></i>
                                                    </div>
                                                    <p className="tool_tip xsm_text text-light">Copy</p>
                                                </div>
                                            )}
                                            {copiedText[`${row.EncounterID}-${row.Patient}`] ? (
                                                <p className={`xsm_text copied_text d-block top-100-5`} >Copied to clipboard</p>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </td>
                                    <td>
                                        <p className="text text-nowrap">
                                            <div className="blue-arrow d-flex justify-content-between align-items-center w-100">
                                                <div className="validation_message" title={row.AccountNumber}>{row.AccountNumber}</div>
                                                <div className="blue-arrow">
                                                    <i className="icon-icon-arrow-top-right fs-8 " onClick={() => handleViewAllClaimAccNumber(row.PatientID + "", row.Patient)}></i>
                                                </div>

                                            </div>
                                            {/* {row.AccountNumber || ''} */}
                                        </p>
                                    </td>
                                    <td>
                                        <p className="text text-nowrap">
                                            <div className="d-flex gap-1 align-items-center justify-content-between w-100 table-copy position-relative">
                                                <div className="copy_icon validation_message" >
                                                    <OpenQuickPopupMemoized row={row} setPopup={setPopup} name={'Provider'} />
                                                </div>
                                                {row.Provider && (
                                                    <div className="app_tooltip left ar-copy-hover">
                                                        <div className="d-flex">
                                                            <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.EncounterID, row.Provider)} ></i>
                                                        </div>
                                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                                    </div>
                                                )}
                                                {copiedText[`${row.EncounterID}-${row.Provider}`] ? (<p className={`xsm_text copied_text d-block top-100-5`} >Copied to clipboard</p>) : (<></>)}
                                            </div>
                                            {/* <OpenQuickPopupMemoized row={row} setPopup={setPopup} name={'Provider'} /> */}
                                            {/* {row.Provider || ''} */}
                                        </p>
                                    </td>
                                    <td>
                                        <div className="d-flex justify-content-between gap-20">
                                            <p className="text text-nowrap">{row.NoteType || ''}
                                                {row.IsAIGenerated === 'true' ?
                                                    <i className='ms-1 icon-ai-encounter' alt={"AI icon"} />
                                                    : null}
                                            </p>
                                            {row.IsGroupEncounter === 'true' ? <i className="icon-group-pateint fs-13"></i> : null}
                                        </div>
                                    </td>
                                    {additionalNotesColExists &&
                                        (<td>
                                            <div className="d-flex justify-content-between gap-20">
                                                <p className="text text-nowrap">{row.AdditionalNotes || ''}
                                                </p>
                                            </div>
                                        </td>)}
                                    <td>
                                        <p className="text text-nowrap">{row.EncounterType || ''}</p>
                                    </td>
                                    <td>
                                        <p className="text text-nowrap">
                                            <div className="d-flex gap-1 align-items-center justify-content-between w-100 table-copy position-relative">
                                                <div className="copy_icon validation_message" >
                                                    <OpenQuickPopupMemoized row={row} setPopup={setPopup} name={'Location'} />
                                                </div>
                                                {row.LocationName && (
                                                    <div className="app_tooltip left ar-copy-hover">
                                                        <div className="d-flex">
                                                            <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.EncounterID, row.LocationName)} ></i>
                                                        </div>
                                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                                    </div>
                                                )}
                                                {copiedText[`${row.EncounterID}-${row.LocationName}`] ? (<p className={`xsm_text copied_text d-block top-100-5`} >Copied to clipboard</p>) : (<></>)}
                                            </div>
                                            {/* <OpenQuickPopupMemoized row={row} setPopup={setPopup} name={'Location'} /> */}
                                            {/* {row.LocationName || ''} */}
                                        </p>
                                    </td>
                                    <td>
                                        <p className="text text-nowrap">
                                            <div className="d-flex gap-1 align-items-center justify-content-between w-100 table-copy position-relative">
                                                <div className="copy_icon validation_message" >
                                                    <OpenQuickPopupMemoized row={row} setPopup={setPopup} name={'Insurance'} />
                                                </div>
                                                {row.Insurance && (
                                                    <div className="app_tooltip left ar-copy-hover">
                                                        <div className="d-flex">
                                                            <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.EncounterID, row.Insurance)} ></i>
                                                        </div>
                                                        <p className="tool_tip xsm_text text-light">Copy</p>
                                                    </div>
                                                )}
                                                {copiedText[`${row.EncounterID}-${row.Insurance}`] ? (<p className={`xsm_text copied_text d-block top-100-5`} >Copied to clipboard</p>) : (<></>)}
                                            </div>
                                            {/* <OpenQuickPopupMemoized row={row} setPopup={setPopup} name={'Insurance'} /> */}
                                            {/* {row.Insurance || ''} */}
                                        </p>
                                    </td>
                                    <td>
                                        <p className="text text-nowrap">{row.EnteredDate || ''}</p>
                                    </td>
                                    {/* <td>{row.AppointmentMode || ''}</td> */}
                                    <td>
                                        <div className="d-flex gap-6 align-itemes-center w-100 ar-action-data">
                                            {row.IsEncounterSigned === "true" ?
                                                ((row.EncounterStatus !== "Signed" && row?.isSignatureAllowed === "true") ? <p className={`text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer ${isSignEditAllowed ? '' : 'disable'}`} onClick={(e) => handleEncounterAction(e, row, 'Sign')}>{row.EncounterStatus === 'To Be Co-Signed' ? 'Co-Sign' : 'Sign'}</p> : <></>) : <></>}

                                            {row.IsSuperBillCreated === "true" ? <p className={`text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer ${isSuperbillEditAllowed ? '' : 'disable'}`} onClick={(e) => handleEncounterAction(e, row, 'Add Superbill')}>Add Superbill</p> : <></>}
                                            {row.IsClaimCreated === "true" ? <div className={`text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer ${isCreateClaimEditAllowed ? '' : 'disable'}`} onClick={(e) => handleCreateClaim(e, row)}>Create Claim</div> : <></>}
                                            {row.IsClaimView === "true" ?
                                                ((row.ClaimID && row.ClaimType) ?
                                                    <div className={`text validate-color br-clr-light br-right-1 pe-1-5 text-nowrap cursor-pointer ${isClaimViewAllowed ? '' : "disable"}`} onClick={(e) => handleViewClaim(e, row)}>View Claim</div>
                                                    : <></>) : <></>}

                                            {/* <i className="icon-delete text-danger" onClick={() => handleDeleteGridModal(row?.EncounterID)}></i> */}
                                            {row.EncounterStatus !== "Signed" ? <i className={isDeleteAllowed ? "icon-delete text-danger br-clr-light br-right-1 pe-1-5" : "icon-delete text-danger pe-none opacity-25 br-clr-light br-right-1 pe-1-5"} onClick={() => handleDeleteGridModal(row?.EncounterID)}></i> : <></>}
                                            {/* <span class='icon-Group-1000002858 fs-13'>
                                                <span class="path1"></span><span class="path2"></span>
                                            </span> */}
                                        </div>
                                    </td>
                                </tr>)
                            }) : null}
                        </tbody>
                    </table>
                </div>
                {!isLoading ? (encounterMenuData.length < 1) ?
                    <NoDataFound isLoading={isLoading} rows={encounterMenuData} />
                    : null : null
                }
                <Pagination
                    PerPage={PerPage}
                    PageNo={PageNo}
                    TotalPages={TotalPages}
                    handlePageClick={handlePageClick}
                    PreviousPage={PreviousPage}
                    handleFingByCreteria={handleFingByCreteria}
                    NextPage={NextPage}
                    // selectedRows={selectedRows}
                    handleSelectData={handleSelectData}
                    RowsDD={'500'}
                    disableInput={true}
                />
                {/* <Table
                    columns={columns}
                    rows={encounterMenuData}
                    height='465px'
                    rowClass={rowClass}
                    dynamicClass='fill-grid DataGrid-Table hk-exp-table two-rows-with-tab encounter_menu_grid'
                    rowHeight={25}
                    PerPage={PerPage}
                    PageNo={PageNo}
                    TotalPages={TotalPages}
                    handlePageClick={handlePageClick}
                    PreviousPage={PreviousPage}
                    handleFingByCreteria={handleFingByCreteria}
                    NextPage={NextPage}
                    Key={21}
                    Name={'EncounterMenuSearch'}
                    isLoading={isLoading}
                    hideColClass='R2-tab-hide'
                    TableName={'EncounterMenu'}
                    colPopup='top-0'
                    handleSelectData={handleSelectData}
                    disableInput={true}
                    LoadData={() => LoadData(searchParam)}
                    ClearSearch={clearFilter}
                /> */}

                {/* <div className={`sidebar-filters ${filterShow && 'active'}`}>
                    <div className="sidebar-filters__heading">
                        <span>Filters</span>
                        <button className="btn btn-transparent" onClick={clearFilter}>
                            <i className="bi bi-x"></i>
                        </button>
                    </div>
                    <hr />
                    <div className="sidebar-filters__body h-100">
                        {/* <div className="input filters-field multipleSearch-rounded">
                            <label>Provider</label>
                            <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="ProviderID"
                                name="ProviderID"
                                selectedOptionsDisplay='Provider'
                                initialSelectedValues={[]}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                options={DropDowns.Provider?.filter(item => !['-1', -1].includes(item.value))}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                        <hr /> */}
                {/* <div className="input filters-field multipleSearch-rounded">
                            <label>Location</label>
                            <SuperSearchMultipleClient
                                key={reloadSuperSearch}
                                id="LocationID"
                                name="LocationID"
                                selectedOptionsDisplay='Location'
                                initialSelectedValues={[]}
                                searchParam={searchParam}
                                setSearchParam={setSearchParam}
                                options={DropDowns.Location?.filter(item => !['-1', -1].includes(item.value))}
                                onSelect={handleMUltiSelectedData}
                                sup_btn="sup_btn-Inp"
                                sup_inp="superSearchVisitInp"
                            />
                        </div>
                        <div className="input filters-field">
                            <div className='input simple_select position-relative'>
                                <label>Coordinator</label>
                                <SuperSearchList
                                    type="client"
                                    id='CoordinatorID'
                                    name='CoordinatorID'
                                    searchValue={selectCoordinator}
                                    data={DropDowns.CoOrdinator}
                                    onChange={(e) => handleChange(e)}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    icon={'Simple'}
                                    sup_btn='sup_simple_btn'
                                    sup_inp='sup_simple_Inp'
                                    className="form-control rounded"
                                />
                            </div>
                        </div>
                        <div className="input filters-field">
                            <CalendaRangeInput searchParam={searchParam} setSearchParam={setSearchParam} options={['Entry Date']} />
                        </div> */}
                {/*</div>
                    <div className="sidebar-filters__footer">
                        <button className="btn btn-orange" onClick={handleApply}>Apply</button>
                    </div>
                </div> */}
            </div>

            {/* Encounter Menu Search Modal */}
            {/* <Modal show={false} onHide={false} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg master_list_modal">
                <Modal.Body>
                    <SearchHeader />
                    <ModalHeader HeaderName={patientHeader} DeletePopup={""} isClosed={() => { }} key={631} Name={'SwitchPractice'} />
                    <div className='container-fluid  br-clr'>
                        <div className="row">
                            <div className="col-12 mb-2 ">
                                <div className="input">
                                    <div className='input-group hk-input-search'>
                                        <input type="text" className='form-control fc-xs'
                                            placeholder='Search by name, DOB, account #, phone #'
                                        // onChange={e => setSearchParam(e.target.value)}
                                        // onKeyDown={SearchOnEnter} 
                                        />
                                        <span className="input-group-text" id="basic-addon2">
                                            <i className="bi bi-search"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="opened-block">
                                    <p className="heading">Recently Opened</p>
                                    <DataGrid
                                        columns={columnsAll}
                                        headerRowHeight={25}
                                        rowHeight={25}
                                        rows={rowsAll}
                                        className="all_audit fill-grid DataGrid-Table bg-light-blue sr-table popper-t-table"
                                    />
                                </div>
                            </div>
                            <div className="col-12 master_footer d-flex gap-3 mt-2 justify-content-end">
                                <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_add">Search</button>
                                <button className="btn btn-orange btn-xs no-width rounded mb-0 master_list_close">Cancel</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal> */}
        </>
    )
}

function mapStateToPropss(state) {
    return {
        OpenDynamicTab: state.Open_EncounterMenu_Tab ? state.Open_EncounterMenu_Tab : [],
        Settings: state.SettingsReducer
    };
}

const action = {
    TabActionEncounterMenu,
};

export default connect(mapStateToPropss, action)(EncounterMenuSearch);

const SignatureBulk = ({ isOpenBulkSignature: isSign, setIsOpenBulkSignature: setIsSign, ...props }) => {
    // console.log("EncounterMenuData 1 isOpenBulkSignature", isSign)
    // console.log("EncounterMenuData 1",props?.encounterMenuData )
    if (props?.encounterMenuData?.length === 0) return;
    let { setSearchParam, getSaveData, selectedEncounterIDs, userSignData } = props;


    const selectedEncounters = props?.encounterMenuData.filter(enc => selectedEncounterIDs?.split(',')
        .map(id => id.trim()).includes(String(enc.EncounterID)));
    let Data = {
        ...selectedEncounters?.[0],
        ProviderSignBy: userSignData?.ProviderSignBy,
        ProviderSignaturePath: userSignData?.ProviderSignaturePath,
        ProviderSignatureFileName: userSignData?.ProviderSignatureFileName
    } || {};
    // console.log("initialDataData", Data)

    return (<>
        <SignEncounter isSign={isSign} setIsSign={setIsSign} providerName={Data?.ProviderName || ''} initialDataData={Data || {}}
            setSearchParam={setSearchParam}
            getSaveData={getSaveData} handleResetBulkSign={props?.handleResetBulkSign} isOpenedFrom={props?.isOpenedFrom} /> : <></>
    </>)
}
const AddNewPatientEncounter = ({ IsEditAllowed, openNewEncounterPopup, setOpenNewEncounterPopup, setIsAiEncounter, isAiEncounter, selectedOption, setSelectedOption, AddNewEncounter, ...props }) => {
    ///////////////////////// Add Encounter Mddal //////////////////////////
    let EncounterMenuData = useSelector(state => state.Open_EncounterMenu_Tab);
    let noteTypes = useSelector(state => state.NoteTypeDDReducer);

    let ENCOUNTER_DEFAULT_MODEL = {
        SOAP: {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "Data": {
                "EncounterID": "",
                // "PatientID": PatientIDR || "",
                "PatientID": "",
                "EncounterType": "",
                "NoteType": "",
                "EncounterDate": "",
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                "ChiefComplaint": "",
                "SubjectiveNotes": "",
                "ObjectiveNotes": "",
                "AssesmentNotes": "",
                "PlanNotes": "",
                "AdditionalInfoNotes": ""
            },
            // "Vital": [],
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare": {},
            // "SuperBill": [],
            // "CognitiveStatus": [],
            // "FunctionalStatus": [],
        },
        GIRP: {
            "TableName": enumUtil.enumAPITableName.GIRPNote,
            "Data": {
                "EncounterID": "",
                // "PatientID": PatientIDR || "",
                "PatientID": "",
                "EncounterType": "",
                "NoteType": "GIRP",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                // "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "GoalsNotes": "",
                "InterventionNotes": "",
                "ResponseNotes": "",
                "PlanNotes": "",
            },
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare": {},
            // "SuperBill": []
        },
        BIRP: {
            "TableName": enumUtil.enumAPITableName.BIRPNote,
            "Data": {
                "EncounterID": "",
                // "PatientID": PatientIDR || "",
                "PatientID": "",
                "EncounterType": "",
                "NoteType": "BIRP",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                // "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "BehaviourNotes": "",
                "InterventionNotes": "",
                "ResponseNotes": "",
                "PlanNotes": "",
            },
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare": {},
            // "SuperBill": []
        },
        DAP: {
            "TableName": enumUtil.enumAPITableName.DAPNote,
            "Data": {
                "EncounterID": "",
                // "PatientID": PatientIDR || "",
                "PatientID": "",
                "EncounterType": "",
                "NoteType": "DAP",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                // "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "DataNotes": "",
                "AssesmentNotes": "",
                "PlanNotes": "",
            },
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare": {},
            // "SuperBill": []
        },
        DAPP: {
            "TableName": enumUtil.enumAPITableName.DAPPNote,
            "Data": {
                "EncounterID": "",
                // "PatientID": PatientIDR || "",
                "PatientID": "",
                "EncounterType": "",
                "NoteType": "DAPP",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                // "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "DataNotes": "",
                "AssesmentNotes": "",
                "ProgressNotes": "",
                "PlanNotes": "",
            },
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare": {},
            // "SuperBill": []
        },
        Therapy: {
            "TableName": enumUtil.enumAPITableName.TherapyNote,
            "Data": {
                "EncounterID": "",
                // "PatientID": PatientIDR || "",
                "PatientID": "",
                "EncounterType": "",
                "NoteType": "Therapy",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                "VitalUnitType": "US Customary",
                "ChiefComplaint": "",
                "SubjectiveNotes": "",
                "ObjectiveNotes": "",
                "InterventionNotes": "",
                "ResponseNotes": "",
                "AssesmentNotes": "",
                "PlanNotes": "",
                "AdditionalInfoNotes": "",

                "FollowUpDate": "",
                "FollowUpNotes": ""
            },
            // "EncounterProblem": [],
            // "CurrentMentalStatus": {},
            // "InterventionsUsed": {},
            // "ResponseObservations": {},
            // "RiskAssessment": [],

            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare": {},
            // "SuperBill": []
        },
        Massage: {
            "TableName": enumUtil.enumAPITableName.MassageNote,
            "Data": {
                "EncounterID": "",
                // "PatientID": PatientIDR || "",
                "PatientID": "",
                "EncounterType": "",
                "NoteType": "Massage",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                // "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "SubjectiveNotes": "<p><strong>Symptoms:</strong></p><p><strong>Pain Level:</strong></p><p><strong>Aggravating/Relieving Factors:</strong></p><p><strong>Functional Limitations/Improvements:</strong></p><p><strong>Any Social/lifestyle factors if relevant:</strong></p>",
                "ObjectiveNotes": "",
                "InterventionNotes": "",
                "ResponseNotes": "",
                "AssesmentNotes": "",
                "PlanNotes": "",
                "AdditionalInfoNotes": "",

                "FollowUpDate": "",
                "FollowUpNotes": ""
            },
            // "EncounterProblem": [],
            // "ObjectiveFinding": {},
            // "RangeOfMotion": {},
            // "AssessmentMethodUsed": {},
            // "AssessmentAreaTreated": {},

            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare" : {},
            // "SuperBill":[]
        },
        Physical: {
            "TableName": enumUtil.enumAPITableName.PhysicalNote,
            "Data": {
                "EncounterID": "",
                // "PatientID": PatientIDR || "",
                "PatientID": "",
                "EncounterType": "",
                "NoteType": "Physical",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                // "VitalUnitType":"US Customary",
                "ChiefComplaint": "",
                "SubjectiveNotes": "<p><strong>Symptoms:</strong></p><p><strong>Pain Level:</strong></p><p><strong>Aggravating/Relieving Factors:</strong></p><p><strong>Functional Limitations/Improvements:</strong></p><p><strong>Any Social/lifestyle factors if relevant:</strong></p>",
                "ObservationNotes": "<p><strong>Posture/Gait:</strong></p><p><strong>Movement:</strong></p><p><strong>Symmetry:</strong></p>",
                "PalpationNotes": "",
                "ObjectiveNotes": "",
                // "InterventionNotes": "",  
                // "ResponseNotes": "",      
                "AssesmentNotes": "",
                "PlanNotes": "",
                "AdditionalInfoNotes": "",

                "FollowUpDate": "",
                "FollowUpNotes": ""
            },
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "RangeOfMotion": {},
            // "Strength": {},
            // "EncounterAddendum": [],
            // "QualityOfCare" : {},
            // "SuperBill":[],
            // "FrontBodyDiagram": [],
            // "BackBodyDiagram": [],
        },
        Other: {
            "TableName": enumUtil.enumAPITableName.OtherNote,
            "Data": {
                "EncounterID": "",
                // "PatientID": PatientIDR || "",
                "PatientID": "",
                "EncounterType": "",
                "NoteType": "Other",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                // "VitalUnitType": "US Customary",
                "ChiefComplaint": "",
                "OtherNote": "",
            },
            // "Vital": [],
            // "EncounterProblem": [],
            // "EncounterDocument": [],
            // "EncounterAddendum": [],
            // "QualityOfCare": {},
            // "SuperBill": []
        },
        CustomNote: {
            "TableName": enumUtil.enumAPITableName.CustomNote,
            "Data": {
                "EncounterID": "",
                "PatientID": "",
                "EncounterType": "",
                "NoteType": "CustomNote",
                "EncounterDate": '',
                "SeenBy": "",
                "Facility": "",
                "EncounterStatus": "In Progress",
                "ChiefComplaint": "",
                // "VitalUnitType":"US Customary",
                // "BehaviourNotes": "",
                // "InterventionNotes": "",
                // "ResponseNotes": "",
                // "PlanNotes": "",
            },
        },
    }

    ///Search///
    const SearchCriteria = {
        "EncounterDate": "",
        "EncounterType": "",
        "NoteType": "",
    }
    const [searchParam, setSearchParam] = useState(SearchCriteria)
    const API_URL_GENERAL_Patient = enumUtil.controller.Patient;
    const API_URL_GENERAL = enumUtil.controller.General;
    const [patientBody, setPatientBody] = useState({
        "TableName": enumUtil.enumAPITableName.Patient,
        "SearchParam": '',
    });
    let valModal = {}
    let ValidationModal = {
        PatientIDVal: "",
        EncounterTypeVal: "",
        NoteTypeVal: "",
        EncounterDateVal: "",
        PatientAppointmentIDVal: "",
        SeenByVal: "",
        FacilityVal: "",
    }
    const [encounterDetailsValidationModal, setEncounterDetailsValidationModal] = useState(ValidationModal)
    // const [hasReloaded, setHasReloaded] = useState(false);
    const defaultNote = isAiEncounter ? noteTypes.filter(item => item.IsAIEnabled)[0] : noteTypes[0];
    const ENCOUNTER_MODEL = {
        "PatientID": '',
        "CopyFromEncounterID": null,
        "EncounterType": "",
        "NoteType": defaultNote?.value || "SOAP",
        "EncounterDate": '',
        "SeenBy": "",
        "Facility": "",
        "PatientAppointmentID": "",
        "EncounterStatus": "In Progress",
        ...(!defaultNote?.IsSystemGenerated && { EHRTemplateID: defaultNote?.EHRTemplateID })
    }
    const [demoData, setDemoData] = useState({
        "SeenBy": "",
        "Facility": "",
    });
    const [saveEncounterParam, setSaveEncounterParam] = useState(ENCOUNTER_MODEL);
    const SearchEncounterName = {
        "PatientID": "",
        "CopyFromEncounterID": null,
        "EncounterType": "",
        "NoteType": defaultNote?.display || "SOAP Note",
        "SeenBy": "",
        "Facility": "",
        "PatientAppointmentID": "",
        "EncounterStatus": "In Progress",
    }
    let dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState(SearchEncounterName)
    const [isLoading, setIsLoading] = useState(false);
    const API_URL = enumUtil.controller.General;
    // const API_URL_Patient = enumUtil.controller.Patient
    const API_URL_PatientEncounter = enumUtil.controller.PatientEncounter;
    const [appointmentData, setAppointmentData] = useState([])
    const [encountersDDData, setEncountersDDData] = useState([]);
    const visitTypes = useSelector(state => state.GeneralDropDownsReducer.EncounterType)
    let providerDD = useSelector(state => state.GeneralDropDownsReducer.Provider);
    let locationDD = useSelector(state => state.GeneralDropDownsReducer.Location);
    const [is, setIs] = useState(true);
    const [isEncounterExistConfirmation, setIsEncounterExistConfirmation] = useState(false);
    const [showParticipant, setShowParticipant] = useState(false);
    let EnableGroupAppointments = useSelector(state => state.SettingsReducer?.EnableGroupAppointments);


    const LoadDD = (patientID) => {
        if (!patientID) return Promise.resolve([]);
        setAppointmentData([]);

        return ServerRequestProtected(API_URL_GENERAL + "/DropDown", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": patientID,
        })
            .then((response) => {
                setAppointmentData(response);
                return response;
            })
            .catch((error) => {
                console.error("Error loading appointment data:", error);
                return [];
            });
    };

    const LoadDDData = (patientID) => {
        if (!patientID) return;
        setEncountersDDData([]);

        ServerRequestProtected(API_URL_GENERAL + "/FindByMultipleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": patientID,
            "SearchCriteria": {
                "Param": "PastEncounter"
            }
        })
            .then((response) => {
                // setIsLoading(false);
                setEncountersDDData(response.Rows);
                // setIs(true);
            }).catch((error) => {
                // setIsLoading(false)
            })
    }

    const LoadDemographicsData = (patientID, openedFor) => {
        if (!patientID) return;
        if (openedFor === "New Encounter" || openedFor === 'New AI Encounter') return; /// navigated from Scheduler, Apply Provider, Location of Appointment
        // if (patientID && patientID !== PatientIDR) return;
        ServerRequestProtected(API_URL + "/FindByID", 'post', {
            // "ID": PatientIDR,
            "ID": patientID,
            "TableName": enumUtil.enumAPITableName.Encounter
        }).then(response => {
            setDemoData({
                SeenBy: response?.ProviderID + "",
                Facility: response?.LocationID + "",
            });
            // setSearchValue(prev => ({...prev, PatientID: response?.display || ""}));

            setSaveEncounterParam(prev => ({
                ...prev,
                SeenBy: response?.ProviderID + "",
                Facility: response?.LocationID + "",
            }));
            let providerSearchVal = DropdownValueHandler(providerDD, response?.ProviderID + "") || "";
            let locationSearchVal = DropdownValueHandler(locationDD, response?.LocationID + "") || "";

            setSearchValue(prev => ({
                ...prev,
                PatientID: response?.display || "",
                SeenBy: providerSearchVal + "",
                Facility: locationSearchVal + "",
            }));
            setIs(true)

            // if(selectedOption === "SelectDate"){
            //     setSaveEncounterParam({ ...saveEncounterParam, 
            //         SeenBy: response?.ProviderID + "" ,
            //         Facility: response?.LocationID + "" ,
            //     });

            //     let providerSearchVal = DropdownValueHandler(providerDD, response.ProviderID)
            //     let locationSearchVal = DropdownValueHandler(locationDD, response.LocationID)
            //     setSearchValue(prev => ({ ...prev, 
            //         SeenBy: providerSearchVal + "" ,
            //         Facility: locationSearchVal + "" ,
            //     }));
            // }
        }).catch(error => {
            // NotificationHandler(error.message, enumUtil.enumtoaster.error)
            // setIsLoading(false)
        })
    }

    const handlePatientSearchChange = (e) => {
        setIs(false)
        // searchValue.PatientID = e.target.value
        setSearchValue(prev => ({ ...prev, PatientID: e.target.value }))
        setPatientBody({ "TableName": enumUtil.enumAPITableName.Patient, "SearchParam": e.target.value })

    }

    let patientID = useRef(null);
    useEffect(() => {

        if (!saveEncounterParam.PatientID) return;
        if (patientID.current === saveEncounterParam.PatientID) return;

        // store new PatientID in ref
        patientID.current = saveEncounterParam.PatientID;

        let id = saveEncounterParam.PatientID + "";
        LoadDemographicsData(id, AddNewEncounter?.data?.openedFor);
        LoadDDData(id);
        LoadDD(id);

    }, [saveEncounterParam?.PatientID])
    useEffect(() => {
        const setupEncounterData = async () => {
            if (AddNewEncounter?.data?.openedFor === 'New Encounter' || AddNewEncounter?.data?.openedFor === 'New AI Encounter') {
                if (AddNewEncounter?.data?.EncounterPopup?.IsGroupAppointment === 'True') {
                    setSelectedOption('GroupAppointment');
                } else {
                    const data = AddNewEncounter?.data?.EncounterPopup;

                    let appointmentDataValue = "";
                    let saveAppointmentDataValue = "";

                    // Load appointment data first if we have PatientID
                    if (data.PatientID) {
                        const loadedAppointmentData = await LoadDD(data.PatientID);
                        if (loadedAppointmentData.length > 0) {
                            appointmentDataValue = DropdownValueHandler(loadedAppointmentData, data.PatientAppointmentID);
                            saveAppointmentDataValue = data.PatientAppointmentID || "";
                        }
                    }

                    // Set all state at once
                    // debugger
                    // let noteType = noteTypes.filter(item => isAiEncounter ? item.IsAIEnabled : !item.isIsAIEnabled)
                    // noteType = noteType.filter(item => !item.IsGroupTemplate)
                    // noteType = noteType.find(item => item.display ===  data.NoteType)
                    const noteType = noteTypes.find(item =>
                        !item.IsGroupTemplate &&
                        (
                            AddNewEncounter?.data?.openedFor !== 'New AI Encounter' ||
                            item.IsAIEnabled
                        ) &&
                        item.display === data.NoteType
                    );
                    let modal = {
                        PatientID: data.PatientName || "",
                        SeenBy: DropdownValueHandler(providerDD, data.SeenBy),
                        Facility: DropdownValueHandler(locationDD, data.Facility),
                        EncounterDate: data.EncounterDate || "",
                        PatientAppointmentID: appointmentDataValue,
                        NoteType: !isNull(noteType) ? noteType.display : '',
                        // DropdownValueHandler(noteTypes.filter(item => !item.IsGroupTemplate), data.NoteType) || '',
                        EncounterType: DropdownValueHandler(visitTypes, data.EncounterType),
                    };

                    let saveModal = {
                        PatientID: data.PatientID || "",
                        SeenBy: data.SeenBy || "",
                        Facility: data.Facility || "",
                        EncounterDate: data.EncounterDate || "",
                        PatientAppointmentID: saveAppointmentDataValue,
                        NoteType: !isNull(noteType) ? noteType.display : '',
                        EncounterType: data.EncounterType || "",
                        ...(data.IsSystemGenerated && (data.IsSystemGenerated !== "true") && { EHRTemplateID: noteType?.EHRTemplateID ? noteType?.EHRTemplateID + "" : '' })
                    };

                    setSearchValue(modal);
                    setSaveEncounterParam(saveModal);
                    setSelectedOption('SelectAppointment');
                }

            }
        };

        setupEncounterData();
    }, [AddNewEncounter]);

    const handleSelectedData = (selectedData, name, type) => {
        setIs(true);
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'CopyFromEncounterID') {
                if ([-1, "-1"].includes(selectedData.value)) {
                    setSaveEncounterParam({ ...saveEncounterParam, [name]: "" })
                    setSearchValue(prev => ({ ...prev, [name]: "" }))
                } else {
                    // console.log("CopyFromEncounterID",selectedData, visitTypes)

                    setSaveEncounterParam({
                        ...saveEncounterParam, [name]: selectedData.value + "",
                        NoteType: selectedData.NoteType + "",
                        SeenBy: selectedData.ProviderID + "",
                        Facility: selectedData.LocationID + "",
                        EncounterType: selectedData.EncounterTypeID + "",

                    })

                    let providerSearchVal = DropdownValueHandler(providerDD, selectedData.ProviderID)
                    let locationSearchVal = DropdownValueHandler(locationDD, selectedData.LocationID);
                    let visitSearchVal = DropdownValueHandler(visitTypes, selectedData.EncounterTypeID);

                    setSearchValue(prev => ({
                        ...prev, [name]: selectedData.display + "",
                        NoteType: (noteTypes.find(note => note?.value === selectedData.NoteType)?.display || '') + "",
                        SeenBy: providerSearchVal + "",
                        Facility: locationSearchVal + "",
                        EncounterType: visitSearchVal + "",
                    }))
                }
            }
            if (name === 'EncounterType') {
                setSaveEncounterParam({ ...saveEncounterParam, EncounterType: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, EncounterType: selectedData.display + "" }))
            }
            if (name === 'NoteType') {
                setSaveEncounterParam(prev => {
                    // remove EHRTemplateID from previous state
                    const { EHRTemplateID, ...rest } = prev;
                    return {
                        ...(selectedData.IsSystemGenerated ? rest : prev),
                        NoteType: String(selectedData.value),
                        ...(!selectedData.IsSystemGenerated && { EHRTemplateID: selectedData.EHRTemplateID }
                        )
                    };
                });
                // setSaveEncounterParam({ ...saveEncounterParam, NoteType: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, NoteType: selectedData.display + "" }))
            }
            if (name === 'SeenBy') {
                setSaveEncounterParam({ ...saveEncounterParam, SeenBy: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, SeenBy: selectedData.display + "" }))
            }
            if (name === 'Facility') {
                setSaveEncounterParam({ ...saveEncounterParam, Facility: selectedData.value + "" })
                setSearchValue(prev => ({ ...prev, Facility: selectedData.display + "" }))
            }
            console.log('selectedData', selectedData);

            if (name === 'PatientAppointmentID') {
                if ([-1, "-1"].includes(selectedData.value)) {
                    setSaveEncounterParam({ ...saveEncounterParam, [name]: "" })
                    setSearchValue(prev => ({ ...prev, [name]: "" }))
                } else {
                    setSaveEncounterParam({
                        ...saveEncounterParam,
                        PatientAppointmentID: selectedData?.value + "",
                        SeenBy: selectedData?.ProviderID + "",
                        Facility: selectedData?.LocationID + "",
                        EncounterDate: selectedData?.AppointmentDate,
                        ChiefComplaint: selectedData?.ChiefComplain,
                        EncounterType: selectedData?.EncounterTypeID ? selectedData?.EncounterTypeID + "" : "",
                        NoteType: selectedData?.DefaultEncounterType ? selectedData?.DefaultEncounterType + "" : '',
                        EHRTemplateID: selectedData?.EHRTemplateID ? selectedData?.EHRTemplateID + "" : '',
                    })
                    let providerSearchVal = DropdownValueHandler(providerDD, selectedData.ProviderID)
                    let locationSearchVal = DropdownValueHandler(locationDD, selectedData.LocationID)
                    setSearchValue(prev => ({
                        ...prev,
                        PatientAppointmentID: selectedData.AppointmentDate + "",
                        SeenBy: providerSearchVal + "",
                        Facility: locationSearchVal + "",
                        EncounterType: selectedData?.DefaultEncounterType ? selectedData?.DefaultEncounterType : '',
                        NoteType: selectedData?.DefaultNoteType ? selectedData?.DefaultNoteType : '',
                    }))
                }
            }
        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'PatientID') {
                if ([-1, "-1"].includes(selectedData.value)) {
                    patientID.current = null;
                    setSaveEncounterParam({ ...saveEncounterParam, PatientAppointmentID: "", CopyFromEncounterID: "", [name]: "" });
                    setSearchValue(prev => ({ ...prev, PatientAppointmentID: "", CopyFromEncounterID: "", [name]: "" }));
                    setEncountersDDData([]);
                    setAppointmentData([]);
                } else {
                    setSaveEncounterParam({ ...saveEncounterParam, [name]: selectedData.value + "" })
                    setSearchValue(prev => ({ ...prev, [name]: selectedData.display + "" }));

                    // console.log("handleEncounterExistssearchValue selectedData123",name,selectedData)

                    // LoadDemographicsData(selectedData.value + "");
                    // LoadDDData(selectedData.value + "");
                    // LoadDD(selectedData.value + "");
                }
            }
        } else {

            if (name === 'PatientID') {
                patientID.current = null;
                setEncountersDDData([]); // Copy From
                setAppointmentData([]); // Appointment DD

                setSaveEncounterParam({ ...saveEncounterParam, PatientAppointmentID: "", CopyFromEncounterID: "", [name]: "" })
                setSearchValue(prev => ({ ...prev, PatientAppointmentID: "", CopyFromEncounterID: "", [name]: "" }));
            } else {
                setSaveEncounterParam({ ...saveEncounterParam, [name]: "" })
                setSearchValue(prev => ({ ...prev, [name]: "" }));
            }

        }
        return selectedData
    }

    const handleCalendarChange = (date) => {
        setSaveEncounterParam({ ...saveEncounterParam, EncounterDate: date + "" })
    }

    const EncounterDetailsValidation = async (duplicateErrorText) => {
        // let duplicateErrorBoolean = duplicateErrorText === "An encounter already exists for the selected date";
        let patientIDVal = [-1, '-1'].includes(saveEncounterParam.PatientID) ? '' : saveEncounterParam.PatientID;
        let encounterTypeVal = [-1, '-1'].includes(saveEncounterParam.EncounterType) ? '' : saveEncounterParam.EncounterType;
        let noteTypeVal = [-1, '-1'].includes(saveEncounterParam.NoteType) ? '' : saveEncounterParam.NoteType;
        let patientAppointmentVal = [-1, '-1'].includes(saveEncounterParam.PatientAppointmentID) ? '' : saveEncounterParam.PatientAppointmentID;
        let seenByVal = [-1, '-1'].includes(saveEncounterParam.SeenBy) ? '' : saveEncounterParam.SeenBy;
        let facilityVal = [-1, '-1'].includes(saveEncounterParam.Facility) ? '' : saveEncounterParam.Facility;

        let ValidationModal = {
            PatientIDVal: FormValidator(
                patientIDVal,
                enumUtil.enumValidationType.Required,
                'Patient',
            ),
            EncounterTypeVal: FormValidator(
                encounterTypeVal,
                enumUtil.enumValidationType.Required,
                'Encounter Type',
            ),
            NoteTypeVal: FormValidator(
                noteTypeVal,
                enumUtil.enumValidationType.Required,
                'Note Type',
            ),
            ...(selectedOption === "SelectAppointment" ?
                {
                    PatientAppointmentIDVal: FormValidator(
                        patientAppointmentVal,
                        enumUtil.enumValidationType.Required,
                        'Patient Appointment',
                    )
                } :
                {
                    EncounterDateVal: isNull(saveEncounterParam.EncounterDate) ?
                        FormValidator(
                            saveEncounterParam.EncounterDate,
                            enumUtil.enumValidationType.Required,
                            'Encounter Date',
                        ) :
                        CurrentMaxDateValidator(
                            saveEncounterParam.EncounterDate,
                            enumUtil.enumValidationType.CurrentDate,
                            'Encounter Date',
                        ),
                })
            ,
            SeenByVal: FormValidator(
                seenByVal,
                enumUtil.enumValidationType.Required,
                'Provider',
            ),
            FacilityVal: FormValidator(
                facilityVal,
                enumUtil.enumValidationType.Required,
                'Location',
            )
        }
        valModal = ValidationModal
        await setEncounterDetailsValidationModal(ValidationModal)
        return valModal;
    }

    const handleSelectDateOption = (e) => {
        setSelectedOption(e.target.value);
        // To Remove Demo Applied Data in case of Select Appointment and Apply in Select Date
        if (selectedOption === "SelectDate" && e.target.value === "SelectAppointment") {
            setSaveEncounterParam(prev => ({ ...ENCOUNTER_MODEL, PatientID: prev.PatientID || "" }));
            setSearchValue(prev => ({ ...SearchEncounterName, PatientID: prev.PatientID || "" }));
        } else if (selectedOption === "SelectAppointment" && e.target.value === "SelectDate") {
            handleApplyDemoData();
        }
    }

    const handleClearOpenedFor = () => {
        if (AddNewEncounter?.data?.openedFor === 'New Encounter' || AddNewEncounter?.data?.openedFor === 'New AI Encounter') {
            let data = [...EncounterMenuData]
            data = data.map(item => {
                if (item.data.id === 0) {
                    return {
                        ...item,
                        active: true,
                        data: {
                            ...item.data,
                            openedFor: null,
                            EncounterPopup: null,
                        }
                    }
                }
                return item;
            })
            dispatch(OpenNewEncounterMenuTabAction(data));
        }

    }
    const handleCloseEncounterPopup = (type) => {
        setIsAiEncounter(false)
        setOpenNewEncounterPopup(false);
        patientID.current = null;
        if (type !== 'saved') {
            handleClearOpenedFor()
        }
        setEncounterDetailsValidationModal(ValidationModal);
        setSaveEncounterParam(ENCOUNTER_MODEL);
        setSearchValue(prev => ({
            ...SearchEncounterName,
            //  PatientID:prev.PatientID || ""
        }));

        setEncountersDDData([]);
        setAppointmentData([]);
        setSelectedOption("SelectAppointment");
        setIs(true);
    }

    const handleApplyDemoData = () => {
        setSaveEncounterParam(prev => ({
            ...prev,
            SeenBy: demoData?.SeenBy + "",
            Facility: demoData?.Facility + "",
        }));
        let providerSearchVal = DropdownValueHandler(providerDD, demoData?.SeenBy) || "";
        let locationSearchVal = DropdownValueHandler(locationDD, demoData?.Facility) || "";
        setSearchValue(prev => ({
            ...prev,
            SeenBy: providerSearchVal + "",
            Facility: locationSearchVal + "",
        }));
    }

    const EncounterName = () => {
        return (
            <p className="heading">New Encounter</p>
        )
    }

    const groupEncounterRef = useRef(null);
    const handleSave = async (updatedParams) => {
        // console.log("handleSave123", `${searchValue?.PatientID?.split(', ')?.[1]} - ${saveEncounterParam.EncounterDate}`)
        if (!IsEditAllowed) return
        if (selectedOption === 'GroupAppointment') {
            handleSaveGroupEncounter()
            return
        }
        const valModal = await EncounterDetailsValidation(); // call child's validate
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            return
        } else {
            setIsLoading(true)
            const getStructerdSaveData = () => {

                let existingNotes = new Set(Object.keys(ENCOUNTER_DEFAULT_MODEL).filter(key => key !== "CustomNote"));
                const noteType = saveEncounterParam?.NoteType;
                let currentNote = existingNotes.has(noteType) ? noteType : "CustomNote";
                // console.log("restObjsaveEncounterParam?.NoteType ", currentNote )
                let { Data, ...restObj } = { ...ENCOUNTER_DEFAULT_MODEL?.[currentNote] };

                let { UpdateDate, UpdatedBy, TableName, ...data } = { ...Data };
                Data = {
                    ...data,
                    // "ChiefComplaint": "",
                    ...saveEncounterParam,
                    IsAIGenerated: isAiEncounter ? 'true' : 'false'
                    // "SubjectiveNotes": "",
                    // "ObjectiveNotes": '',
                    // "AssesmentNotes": '',
                    // "PlanNotes": '',
                    // "AdditionalInfoNotes": '',
                };
                restObj = {
                    ...restObj,
                    // "Vital": [],
                    // "EncounterProblem": [],
                    // "EncounterDocument": [],
                }

                // setAddVital(false);
                return { ...restObj, Data };
            }
            let saveData = getStructerdSaveData();
            if (updatedParams?.SaveDuplicateEncounter === "true") {
                saveData.Data.SaveDuplicateEncounter = updatedParams.SaveDuplicateEncounter;
            }
            // console.log("handleEncounterExists saveData", updatedParams);
            // console.log("saveData", saveData)
            let API_URL_NOTE = saveEncounterParam?.NoteType === 'SOAP' ?
                "/SaveSOAPEncounter" :
                saveEncounterParam?.NoteType === 'GIRP' ?
                    "/SaveGIRPNote" :
                    saveEncounterParam?.NoteType === 'BIRP' ?
                        "/SaveBIRPNote" :
                        saveEncounterParam?.NoteType === 'DAP' ?
                            "/SaveDAPNote" :
                            saveEncounterParam?.NoteType === 'DAPP' ?
                                "/SaveDAPPNote" :
                                saveEncounterParam?.NoteType === 'Therapy' ?
                                    "/SaveTherapyNote" :
                                    saveEncounterParam?.NoteType === 'Massage' ?
                                        "/SaveMassageNote" :
                                        saveEncounterParam?.NoteType === 'Physical' ?
                                            "/SavePhysicalNote" :
                                            saveEncounterParam?.NoteType === 'Other' ?
                                                "/SaveOtherNote" : "/SaveCustomNote";
            ServerRequestProtected(API_URL_PatientEncounter + API_URL_NOTE, 'post', {
                ...saveData
            })
                .then((response) => {
                    setIsLoading(false);
                    createPortal(
                        NotificationHandler('Record Saved Successfully', enumUtil.enumtoaster.success),
                        document.getElementById('root')
                    );
                    // console.log("saveEncounterParamdd",saveEncounterParam)
                    let data = [...EncounterMenuData]
                    data = data.map(item => {
                        if (item.data.id === 0) {
                            return {
                                ...item,
                                active: false,
                                data: {
                                    ...item.data,
                                    openedFor: null,
                                    EncounterPopup: null,
                                }
                            }
                        }
                        return item;
                    })
                    const patientName = searchValue?.PatientID?.split(', ')?.[1] || searchValue?.PatientID?.split(' ')?.[0] || searchValue.PatientID || '';;
                    console.log("dataAddNewEncounter searchValue split", patientName)
                    let obj = {
                        active: true,
                        key: 2,
                        name: "Encounter Menu",
                        data: {
                            name: `${patientName} - ${saveEncounterParam.EncounterDate}`,
                            id: response.id,
                            patid: saveEncounterParam.PatientID,
                            // patID: PatientIDR,
                            type: saveEncounterParam.NoteType,
                            time: new Date()
                        },
                    }
                    data.push(obj);
                    dispatch(OpenNewEncounterMenuTabAction(data));
                    // props.TabActionEncounterMenu(obj);
                    handleCloseEncounterPopup('saved');
                    dispatch(ReloadGridAction({ EncounterMenuSearch: true }));
                }).catch((error) => {
                    // setDuplicateError(error?.response?.data === "An encounter already exists for the selected date")
                    // EncounterDetailsValidation(error?.response?.data);
                    setIsLoading(false)
                    // console.log("Error Error", error?.response?.data)
                    if (error?.response?.data === "An encounter already exists for the selected date") {
                        handleEncounterExists(saveData.Data.EncounterDate);
                    } else {
                        error?.response?.data && NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error);
                    }
                })
        }
    }

    const confirmationMsg = (EncounterDate) => {
        return new Promise((resolve, reject) => {
            const handleConfirmation = (userConfirmed) => {
                if (userConfirmed) {
                    resolve(userConfirmed);
                } else { reject(userConfirmed); }
                setIsEncounterExistConfirmation(<></>);
            };
            setIsEncounterExistConfirmation(
                <Modal show={true} onHide={() => handleConfirmation(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar_select_opt  za-update-subscriber-id za-discard-changes za-exit-group ">
                    <ModalHeader HeaderName={Heading} DeletePopup={""} isClosed={() => handleConfirmation(false)} key={6331} Name={'DuplicateEncounter'} />
                    <Modal.Body>
                        <div className='ar-alert d-flex mb-12'>
                            <i className='icon-Vector13 mt-1'></i>
                            <div>
                                <p className='text ms-1'>Encounter already exists for {EncounterDate}. Do you want to create another encounter?</p>
                            </div>
                        </div>
                    </Modal.Body>

                    <div className="modal_footer za_br_light br-top-1 pt-2 ">
                        <div className='za-button text-end d-flex justify-content-end gap-2'>
                            <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={() => handleConfirmation(false)}>No</button>
                            <button className='btn btn-danger fs-12 px-10 rounded' onClick={() => handleConfirmation(true)}>Yes</button>
                        </div>
                    </div>
                </Modal>)
        })
    }

    const Heading = () => {
        return <p className='heading Rejected_clr'>Confirmation Message</p>;
    };

    const handleEncounterExists = async (EncounterDate) => {
        const userConfirmed = await confirmationMsg(EncounterDate);
        // console.log("handleEncounterExists", userConfirmed);
        if (userConfirmed) {
            let updatedParams = { ...searchParam, SaveDuplicateEncounter: "true" };
            setSearchParam(() => updatedParams);
            handleSave(updatedParams);
        }
    }
    // console.log("handleEncounterExistssearchValue", demoData, searchValue, saveEncounterParam);
    ////////////////////////////==============////////////////////////////////

    // Group Encounter 
    // const groupEncounterRef = useRef(null);
    const handleSaveGroupEncounter = () => {
        const isValid = groupEncounterRef.current.validate();
        if (!isValid) {
            return;
        } else {
            const saveData = groupEncounterRef.current.getSaveData();
            console.log(saveData);
            setIsLoading(true)
            ServerRequestProtected(API_URL_PatientEncounter + '/SaveGroupNote', 'post', {
                "TableName": enumUtil.enumAPITableName.GroupNote,
                'Data': saveData
            })
                .then((response) => {
                    setIsLoading(false);
                    createPortal(
                        NotificationHandler('Record Saved Successfully', enumUtil.enumtoaster.success),
                        document.getElementById('root')
                    );
                    let data = [...EncounterMenuData]
                    data = data.map(item => {
                        if (item.data.id === 0) {
                            return {
                                ...item,
                                active: false,
                                data: {
                                    ...item.data,
                                    openedFor: null,
                                    EncounterPopup: null,
                                }
                            }
                        }
                        return item;
                    })
                    // const patientName = searchValue?.PatientID?.split(', ')?.[1] || searchValue?.PatientID?.split(' ')?.[0] || searchValue.PatientID || '';;
                    // console.log("dataAddNewEncounter searchValue split", patientName)
                    let obj = {
                        active: true,
                        key: 2,
                        name: "Encounter Menu",
                        data: {
                            // name: `${response.patientFirstName} - ${saveData.EncounterDate}`,
                            name: 'Group Encounter' + ' - ' + saveData.EncounterDate,
                            id: response.groupIdentifier,
                            patid: response.patientID,
                            // patID: PatientIDR,
                            type: saveData.NoteType,
                            time: new Date(),
                            groupEncounter: {
                                isGroupEncounter: 'true',
                                GroupIdentifier: response.groupIdentifier,
                                showGroupNote: true
                            }
                        },
                    }
                    data.push(obj);
                    dispatch(OpenNewEncounterMenuTabAction(data));
                    // props.TabActionEncounterMenu(obj);
                    handleCloseEncounterPopup('saved');
                    dispatch(ReloadGridAction({ EncounterMenuSearch: true }));
                }).catch((error) => {
                    // setDuplicateError(error?.response?.data === "An encounter already exists for the selected date")
                    // EncounterDetailsValidation(error?.response?.data);
                    setIsLoading(false)
                    if (error?.response?.data === "An encounter already exists for the selected date") {
                        handleEncounterExists(saveData.Data.EncounterDate);
                    } else {
                        error?.response?.data?.error && NotificationHandler(error?.response?.data?.error, enumUtil.enumtoaster.error);
                    }
                })
        }
    }
    return (
        <>
            {isEncounterExistConfirmation}
            <Modal show={openNewEncounterPopup} onHide={handleCloseEncounterPopup} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 add_new_encounter_popup">
                <Modal.Body>
                    <ModalHeader HeaderName={EncounterName} DeletePopup={''} isClosed={handleCloseEncounterPopup} />
                    <div className="">
                        {isLoading ? <Loader /> : null}
                        <div className="d-flex align-items-center gap-15 mb-12">
                            <label className="ar_radio-btn d-flex align-items-center gap-6">
                                <input type="radio"
                                    name="appointmentOption"
                                    value='SelectAppointment'
                                    checked={selectedOption === "SelectAppointment"}
                                    onChange={handleSelectDateOption}
                                />
                                <span className="text ar-orange-text">Select Appointment</span>
                            </label>
                            <label className="ar_radio-btn d-flex align-items-center gap-6">
                                <input
                                    type="radio"
                                    name="appointmentOption"
                                    value='SelectDate'
                                    checked={selectedOption === "SelectDate"}
                                    onChange={handleSelectDateOption}
                                />
                                <span className="text ar-orange-text">Select Date</span>
                            </label>
                            {EnableGroupAppointments ?
                                <label className="ar_radio-btn d-flex align-items-center gap-6">
                                    <input
                                        type="radio"
                                        name="appointmentOption"
                                        value='GroupAppointment'
                                        checked={selectedOption === "GroupAppointment"}
                                        onChange={handleSelectDateOption}
                                    />
                                    <span className="text ar-orange-text">Group Appointment</span>
                                </label> : null}
                        </div>

                    </div>

                    {selectedOption !== 'GroupAppointment' ?
                        <div className="d-flex flex-column gap-2">
                            <div className={`m-0 ${encounterDetailsValidationModal.PatientIDVal ? 'input error planSearch-module' : 'input planSearch-module'}`}>
                                <SuperSearchList
                                    type='server'
                                    id='PatientID'
                                    name='PatientID'
                                    searchValue={searchValue.PatientID}
                                    ApiLink={API_URL_GENERAL_Patient + "/InstantSearchWithDetails"}
                                    method='post'
                                    postBody={patientBody}
                                    onChange={handlePatientSearchChange}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    sup_btn='sup_btn-Inp'
                                    sup_inp='superSearchVisitInp'
                                    icon={true}
                                    PatientDeatailedInst={true}
                                    placeholder={"Type 3 or more characters to search..."}
                                    inputError={encounterDetailsValidationModal.PatientIDVal}
                                    isReadOnly={false}
                                    disabled={false}
                                />
                                {encounterDetailsValidationModal.PatientIDVal}
                            </div>
                            {selectedOption === 'SelectAppointment' && (
                                <div className={`input form-group ar-multiple-br m-0 pateint-serach-no-rounded ${encounterDetailsValidationModal.PatientAppointmentIDVal ? 'error' : ''}`}>
                                    <label className="pb-3px">Appointment</label>
                                    <SuperSearchSingleClient
                                        type="client"
                                        id='PatientAppointmentID'
                                        name='PatientAppointmentID'
                                        icon={'Simple'}
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                        searchValue={searchValue.PatientAppointmentID}
                                        // data={appointmentData}
                                        data={handleSetDropdownData(appointmentData, { functions: ['setEmptyDefault'] })}
                                        onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, PatientAppointmentID: e.target.value }) }}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        placeholder={false}
                                        SuperSearchView="DetailedView"
                                        DetailedView="PatientEncounterAppt"
                                        inputError={encounterDetailsValidationModal?.PatientAppointmentIDVal}
                                    />
                                    {encounterDetailsValidationModal.PatientAppointmentIDVal}
                                </div>)}

                            {selectedOption === 'SelectDate' && (

                                <div className={`input form-group m-0 w-100 ${encounterDetailsValidationModal.EncounterDateVal ? 'error' : ''}`}>
                                    <label className="pb-3px">Date</label>
                                    {/* <DatePicker /> */}
                                    <DatePicker
                                        value={saveEncounterParam.EncounterDate}
                                        handleCalendarChangefunc={date => handleCalendarChange(date)}
                                        maxDate={new Date()}
                                        showLabel={false}
                                    />
                                    {encounterDetailsValidationModal.EncounterDateVal}
                                </div>)}

                            {!isAiEncounter && (
                                <div className={`form-group input mb-0`}>
                                    <label className="pb-3px">Copy From</label>
                                    <div className="input form-group ar-multiple-br m-0">
                                        <div className="ar-multiple-br">
                                            <SuperSearchSingleClient
                                                type="client"
                                                id='CopyFromEncounterID'
                                                name='CopyFromEncounterID'
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                searchValue={searchValue.CopyFromEncounterID}
                                                data={handleSetDropdownData(encountersDDData, { functions: ['removeNegativeValue', 'removeSelfPay', 'setEmptyDefault'] })}
                                                onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, CopyFromEncounterID: e.target.value }) }}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                placeholder={false}
                                                SuperSearchView="DetailedView"
                                                DetailedView="PatientPastEncounter"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                            {/* {selectedOption === 'SelectAppointment' && (
                            <div className="client_detail gap-2 d-flex position-relative group-appointment">
                                <div className="d-flex flex-column gap-1 w-100">
                                    <p className='heading'>Participants</p>
                                    <div className="d-flex align-items-center justify-content-between gap-20 w-100">
                                        <div className="d-flex align-items-center gap-6">
                                            <i className='icon-group-pateint fs-13'></i>
                                            <p className="text font-m">Alicia, Johnson, +4 more</p>
                                        </div>

                                        <p className="heading za-blue-clr fs-11 user-select-none cursor-pointer lh-18" onClick={() => setShowParticipant(!showParticipant)}>{showParticipant ? 'Hide All' : 'Show All'} </p>
                                    </div>

                                    {showParticipant ? <div className="d-flex flex-column gap-5">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p className='text fs-11 ar-bullet ps-10'><span className='font-m fs-12'>Hazel, Roy</span> 6/1/2002 (33 Y) M</p>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center">
                                            <p className='text fs-11 ar-bullet ps-10'><span className='font-m fs-12'>Hazel, Roy</span> 6/1/2002 (33 Y) M</p>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center">
                                            <p className='text fs-11 ar-bullet ps-10'><span className='font-m fs-12'>Hazel, Roy</span> 6/1/2002 (33 Y) M</p>

                                        </div>
                                    </div> : <></>}


                                </div>
                            </div>
                        )} */}

                            <div className={`form-group input mb-0 ${encounterDetailsValidationModal.SeenByVal ? 'error' : ''}`}>
                                <label className="pb-3px">Provider</label>
                                <div className="input form-group ar-multiple-br m-0">
                                    <SuperSearchList
                                        type="client"
                                        id='SeenBy'
                                        name='SeenBy'
                                        icon={'Simple'}
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                        searchValue={searchValue.SeenBy}
                                        data={providerDD}
                                        onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, SeenBy: e.target.value }) }}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        placeholder={false}
                                        inputError={encounterDetailsValidationModal?.SeenByVal}
                                    />
                                    {encounterDetailsValidationModal.SeenByVal}
                                </div>
                            </div>

                            <div className={`form-group input mb-0 ${encounterDetailsValidationModal.FacilityVal ? 'error' : ''}`}>
                                <label className="pb-3px">Location</label>
                                <div className="input form-group ar-multiple-br m-0">
                                    <SuperSearchList
                                        is={is}
                                        type="client"
                                        id='Facility'
                                        name='Facility'
                                        icon={'Simple'}
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                        searchValue={searchValue.Facility}
                                        data={locationDD}
                                        onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, Facility: e.target.value }) }}
                                        getSelectedData={handleSelectedData}
                                        placeholder={false}
                                        inputError={encounterDetailsValidationModal?.FacilityVal}
                                    />
                                    {encounterDetailsValidationModal.FacilityVal}
                                </div>
                            </div>

                            <div className={`input form-group ar-multiple-br m-0 ${encounterDetailsValidationModal.EncounterTypeVal ? 'error' : ''}`}>
                                <label className="pb-3px">Encounter Type</label>
                                <SuperSearchList
                                    type="client"
                                    id='EncounterType'
                                    name='EncounterType'
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                    searchValue={searchValue.EncounterType}
                                    data={visitTypes}
                                    onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, EncounterType: e.target.value }) }}
                                    getSelectedData={handleSelectedData}
                                    is={is}
                                    placeholder={false}
                                    inputError={encounterDetailsValidationModal?.EncounterTypeVal}
                                />
                                {encounterDetailsValidationModal?.EncounterTypeVal}
                            </div>

                            <div className={`form-group input mb-0 ${encounterDetailsValidationModal.NoteTypeVal ? 'error' : ''}`}>
                                <label className="pb-3px">Note Type</label>
                                {isAiEncounter ?
                                    <div className="input form-group ar-multiple-br m-0">
                                        <SuperSearchList
                                            type="client"
                                            id='NoteType'
                                            name='NoteType'
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            searchValue={searchValue.NoteType}
                                            data={handleSetDropdownData(noteTypes.filter((item => !item.IsGroupTemplate && item.IsAIEnabled)), { functions: ['setEmptyDefault'] })}
                                            onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, NoteType: e.target.value }) }}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            placeholder={false}
                                            inputError={encounterDetailsValidationModal?.NoteTypeVal}
                                            isReadOnly={(saveEncounterParam?.CopyFromEncounterID)} //|| isAiEncounter ? true : false
                                            disabled={(saveEncounterParam?.CopyFromEncounterID)} //|| isAiEncounter ? true : false
                                        />
                                        {encounterDetailsValidationModal.NoteTypeVal}
                                    </div>
                                    : <div className="input form-group ar-multiple-br m-0">
                                        <SuperSearchList
                                            type="client"
                                            id='NoteType'
                                            name='NoteType'
                                            icon={'Simple'}
                                            sup_btn='sup_btn'
                                            sup_inp='superSearchVisitInp'
                                            searchValue={searchValue.NoteType}
                                            data={handleSetDropdownData(noteTypes.filter((item => !item.IsGroupTemplate)), { functions: ['setEmptyDefault'] })}
                                            onChange={(e) => { setIs(false); setSearchValue({ ...searchValue, NoteType: e.target.value }) }}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            placeholder={false}
                                            inputError={encounterDetailsValidationModal?.NoteTypeVal}
                                            isReadOnly={(saveEncounterParam?.CopyFromEncounterID)} //|| isAiEncounter ? true : false
                                            disabled={(saveEncounterParam?.CopyFromEncounterID)} //|| isAiEncounter ? true : false
                                        />
                                        {encounterDetailsValidationModal.NoteTypeVal}
                                    </div>
                                }
                            </div>
                        </div>
                        : <AddNewGroupEncounter
                            isAiEncounter={isAiEncounter}
                            ref={groupEncounterRef}
                            AddNewEncounter={AddNewEncounter}
                        />}
                </Modal.Body>
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light ar_footer justify-content-end">
                    <div className="btns-group">
                        <button className={`btn btn-validate px-10 h-100 d-flex align-items-center gap-1 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSave}>
                            Proceed
                            <i className="icon-Symbol-24--25 text-white fs-12"></i>
                        </button>
                    </div>
                </div>

            </Modal>
        </>
    )
}
